import level1 from "./level1";

export default {
  level1: level1,
  bidDialog: {
    notPassAudit: "プロジェクトは監査に合格しませんでした。今、{fundsPaid} USDCの投資を払い戻しすることができます。",
    canNowWithdraw: "今、{fundsPaid} USDCの投資を引き出すことができます。",
    seeTransaction: "取引を見る",
    biddingEnded: "残念ながら、入札期間が終了し、登録オファーは処理されませんでした。",
    youHave: "あなたは持っています",
    allocations: "割り当て",
    title: "{projectName} からカーボンクレジットを入札してください",
    whitelisted: "あなたは、${listingPrice} の価格でプロジェクト {projectName} からカーボンクレジットを購入するとホワイトリストに登録されています",
    network: "ネットワーク",
    smartContract: "スマートコントラクト",
    price: "価格",
    youReceive: "あなたは受け取ります",
    remainingAllocation: "残りの割り当て量",
    youPay: "あなたが支払います",
    balance: "残高",
    gasEstimated: "ガス（推定）",
    bid: "入札",
    setSpendingCap: "支出上限を設定してください",
    bidTransaction: "入札取引",
    status: "ステータス",
    notWhitelisted: "あなたはこのカーボンクレジットオファリングのホワイトリストに登録されていないか、すでに割り当てを完了しています。今後のカーボンクレジットオファリングに参加するには、ブラジルカーボンチームに連絡してください",
    switchNetwork: "カーボンクレジットを購入するには、{requiredNetworkName} に切り替える必要があります。このプロジェクトはネットワークID {projectId} にあり、現在あなたはネットワークID {networkId} に接続しています。",
    investmentTitle: "あなたは投資に成功しました",
    investmentText: "{ showAmount } { symbol } を受け取りました",
    investmentText2: "{ name } から { showAmount } カーボンクレジットを正常に購入しました。",
    investmentText3: "ブロックチェーンエクスプローラーでトランザクションの詳細を表示することもできます。",
    investmentText4: "{ name } から { showAmount } 枚のアグロフロレストリートークンを正常に購入しました。",
    wallet: "ウォレット",
    page: "ページ",
    max: "最大",
    unknownNetwork: "不明なネットワーク",
    backToBid: "入札に戻る",
    error: "エラー",
    biddingClosed: "入札は終了しました",
    biddingClosedText: "残念ながら、入札期間が終了し、登録オファーは処理されませんでした。",
    hours: "時",
    minutes: "分",
    left: "残り",
    currentBid: "現在の入札額",
    for: "に対して",
    insufficientFund: "残高不足",
    placeBid: "入札する",
    fullyBidAllocations: "割り当て分すべてに入札済みです",
    carbonCredit: "カーボンクレジット",
    AgroforestryProducts: "アグロフォレストリー製品"
  },
  connectButton: {
    account: "アカウント",
    manageAccount: "アカウント管理",
    connectWallet: "ウォレットを接続",
    signedInAs: "としてサインイン",
    acmeGmbH: "Acme GmbH",
    copyAddressTooltip: "住所をコピー",
    viewOnExplorerTooltip: "エクスプローラーで表示",
    myWallet: "マイウォレット",
    disconnect: "接続解除",
    totalCredit: "合計クレジット",
    projectFunded: "資金提供されたプロジェクト",
    openWallet: "ウォレットを開く",
    login: "ログイン",
    loginToInvest: "投資するにはログインしてください",
    currentYear: "現在の年"
  },
  connectDialog: {
    loginWithEmail: "メールでログイン",
    continueWithWallet: "またはウォレットで続行",
    login: "ログイン",
    email: "メールアドレス",
    password: "パスワード",
    login_farmer: "農家としてログイン",
    title: "ウォレットを接続して",
    description: "ウォレットについて詳しく知る",
    signIn: "サインイン",
    connectingWallet: "ウォレットに接続しています",
    clickConnect: "ウォレットのポップアップで「接続」をクリックしてください",
    selectAccount: "このサイトで使用するアカウントを選択してください。",
    ledgerSteps: {
      step1: "Ledgerデバイスをコンピューターに接続します。",
      step2: "PINを入力してデバイスにアクセスします。",
      step3: "Avalancheアプリをインストールし、デバイスで開いていることを確認してください。",
      step4: "デバイス上でウォレットアドレスを確認します。",
      step5: "Ledgerに表示されるメッセージに署名して、サインインプロセスを完了します。"
    },
    retry: "再試行",
    noWallets: "ウォレットがありませんか？",
    welcome: "Brazil Carbonへようこそ",
    login_investor: "投資家としてログイン",
    login_developer: "開発者としてログイン",
    continue_farmer: "農家として続行",
    continue_investor: "投資家として続行",
    continue_developer: "開発者として続行",
    back: "戻る",
    cancel: "キャンセル",
    walletConnectTimeout: "ウォレット接続がタイムアウトしました。もう一度お試しください。",
    walletConnectionFailed: "ウォレットに接続できませんでした。もう一度お試しください。",
    invalid_cred: "無効な資格情報",
    loginOrSignUp: "ログインまたはサインアップ"
  },
  footerComp: {
    committed: "コミット",
    copyright: {
      line1: "©2023 ブラジルカーボン技術会社",
      line2: "全著作権所有。この製品は著作権で保護されており、コピー、配布、逆コンパイルを制限するライセンスの下で配布されています。"
    },
    navigation: {
      helpPage: "ヘルプ",
      contact: "連絡先"
    },
    tagline: "ブラジルの実体経済バイオエコノミー・プロジェクトに投資",
    copyrightNew: "© Brazil Carbon 2026",
    invest: {
      title: "投資する",
      carbonCredits: "カーボンクレジット",
      agroforestry: "アグロフォレストリー"
    },
    participate: {
      title: "参加する",
      listProject: "プロジェクトを掲載",
      partnerWithUs: "パートナーになる"
    },
    getInTouch: {
      title: "お問い合わせ",
      linkedin: "LinkedIn",
      contactUs: "お問い合わせ"
    },
    privacyPolicy: "プライバシーポリシー"
  },
  registerCard: {
    registerApproved: "登録が承認されました",
    approved: "承認済み",
    rejected: "却下されました",
    awaitingApproval: "承認待ち"
  },
  investCard: {
    state: "状態",
    creditType: "クレジットタイプ",
    creditTypeOptions: {
      reforestation: "植林",
      soilSequestration: "土壌隔離",
      energyEfficiency: "エネルギー効率",
      carbonMethaneCapture: "炭素メタン回収",
      renewableEnergyDevelopment: "再生可能エネルギー開発",
      highPotencyGHGCapture: "高効率温室効果ガス回収",
      avoidDeforestation: "森林伐採の回避",
      community: "コミュニティ",
      wasteToEnergy: "廃棄物からエネルギーへ"
    },
    tokenSymbol: "トークン・シンボル",
    balance: "バランス",
    projectDetailsButton: "プロジェクト詳細"
  },
  ownerCard: {
    manageWallet: "ウォレットを管理",
    offeringState: {
      tba: "後日発表",
      paused: "一時停止",
      live: "ライブ",
      finalized: "完了",
      inactive: "非アクティブ",
      unsuccessful: "失敗",
      noOffering: "オファーなし",
      registered: "登録済み",
      registerClosed: "登録終了",
      pendingOffering: "提供申請中",
      successful: "成功",
      awaitingApprove: "承認待ち"
    },
    auditUnsuccess: "監査失敗",
    awaitingApprove: "承認待ち",
    allocation: "割り当て",
    fundsRaised: "調達した資金",
    total: "合計",
    network: "[ネットワーク]",
    contract: "契約",
    status: "ステータス",
    statusValues: {
      inactive: "[非アクティブ]",
      offeringPeriod: "オファリング期間",
      lockedUntil: "までロック状態",
      unlocked: "ロック解除",
      withdrawn: "撤回された (てっかいされた)",
      unsuccessful: "「失敗した」"
    },
    state: "状態",
    tokenSymbol: "トークン・シンボル",
    projectDetailsButton: "プロジェクト詳細",
    auditTimeline: "カーボンクレジット監査タイムライン",
    audit: "監査",
    copyAddress: "住所をコピー",
    viewOnExplorer: "エクスプローラーで表示",
    auditPeriod: "監査期間"
  },
  navBar: {
    about: "アバウト",
    projects: "プロジェクト",
    token: "トークン",
    jurisdictionCredit: "管轄クレジット",
    dashboard: "ダッシュボード",
    beta: "ベータ",
    investInProjects: "プロジェクトに投資する",
    buyCarbonCredits: "カーボンクレジットを購入する",
    myDashboard: "マイダッシュボード"
  },
  registerDialog: {
    tonsUpper: "トン",
    agroforestry: "アグロフォレストリー",
    discoverOtherProjects: "他のプロジェクトを発見する",
    connectedWallet: "接続されたウォレット",
    walletAddress: "ウォレットアドレス",
    registration: "登録",
    businessName: "ビジネス名",
    maxSupplyText: "このプロジェクトのすべてのカーボンクレジットが割り当てられました。他のプロジェクトを探索して、利用可能な機会を見つけてください。",
    required: "この項目は必須です",
    businessNameMaxLength: "会社名は最大255文字までです",
    fullName: "氏名",
    fullNameMaxLength: "氏名は最大255文字までです",
    businessIncorporationDate: "事業設立日",
    dateInvalid: "有効な日付を DD-MM-YYYY 形式で入力してください",
    yearMustBeCurrentOrEarlier: "日付は今日以前でなければなりません。",
    email: "メールアドレス",
    emailInvalid: "有効なEメールアドレスを入力してください",
    oneCreditEquals: "1 クレジット = {price} USDC",
    maxSupply: "最大供給量: {maxSupply}",
    maxSupplyTitle: "カーボンクレジットが完全に割り当てられました",
    amountGreater: "金額は 0 より大きくなければなりません。",
    amountMaxSupply: "量は供給可能量以下でなければなりません。",
    walletAddressInvalid: "有効なウォレットアドレスを入力してください",
    pasteWallet: "接続されているウォレットアドレスを貼り付けてください",
    connectWallet: "ウォレットを接続して住所を貼り付けます。",
    verification: "認証",
    amlCheck: "AML チェック",
    performingAmlCheck: "AML チェックを実行中...",
    amlCheckPassed: "AML チェックは正常に終了しました!",
    back: "< 戻る",
    continue: "続行",
    register: "登録",
    toBeAnnounced: "価格は後日発表予定",
    registerClosed: "登録は終了しました",
    onlyRegisteredBid: "入札は登録済みの購入者のみ可能です",
    offerFinalized: "オファーが終了しました",
    youAreRegisteredTitle: "登録完了！",
    youRequested: "あなたが要求した",
    credits: "クレジット",
    changeAllocation: "配分を変更する",
    unableApprove: "承認できません",
    unableApproveText: "慎重に検討した結果、現時点でお申し込みを承認できないことをお知らせいたします",
    registerEnded: "登録が終了しました",
    sendEmail: "販売が開始され次第、メールでお知らせします",
    registerSale: "販売に登録する",
    information: "情報",
    amount: "数量",
    available: "利用可能",
    carbonCredit: "カーボンクレジット",
    AgroforestryProducts: "アグロフォレストリー製品",
    creditsCapital: "クレジット",
    carbonCredits: "カーボンクレジット",
    agroProducts: "アグロフォレストリー製品",
    verifying: "確認中",
    verifyingText: "1分ほどかかる場合があります。 しばらくお待ちください！",
    verifyingButton: "登録が送信されました",
    insufficientFund: "残高不足",
    submit: "送信",
    logo: "会社のロゴ",
    webPage: "ウェブサイトのURL",
    companyRegistryNumber: "会社登録番号",
    dateOfIncorporation: "設立日",
    phone: "電話番号",
    invalidUrl: "有効なURLを入力してください（例：https://example.com）",
    companyRegistryMaxLength: "会社登録番号は最大50文字までです",
    invalidPhone: "有効な電話番号を入力してください"
  },
  networkButton: {
    networkIconAlt: "ネットワークアイコン",
    mainnetsTab: "メインネット",
    testnetsTab: "テストネット",
    switchNetwork: "スイッチネットワーク"
  },
  withdrawComp: {
    unlockedFunds: "ロック解除された資金",
    nextUnlock: "次回のロック解除",
    withdraw: "お引き出し",
    withdrawWithAmount: "お引き出し ${remainingFundsUnlocked}",
    usdcCommission: "USDCの手数料",
    creditCommission: "クレジットの手数料"
  },
  contactPage: {
    contactUs: "お問い合わせ"
  },
  projectsPage: {
    title: "「質の高いプロジェクトを探る」",
    allProjectsTitle: "全プロジェクト",
    registerClosed: "登録終了",
    registered: "登録済み",
    noCreditsAvailable: "利用可能なクレジットはもうありません！",
    totalCredits: "クレジット (合計)",
    pricePerTon: "/メートルトン (CO₂e)",
    bid: "入札",
    register: "登録する",
    offeringFinalized: "オファリングが確定しました。",
    offeringCreated: "オファリングが作成されました。",
    participantsWhitelisted: "参加者はホワイトリストに登録されました。",
    upcomingOffering: "今後のオファリング",
    allocated: "割り当て済み",
    total: "合計クレジット",
    startRefund: "返金開始 (へんきんかいし)",
    withdraw: "引き出す (ひきだす)",
    withdrawn: "引き出された (ひきだされた)",
    paused: "「一時停止」",
    landHectaresTitle: "1.2k",
    landHectaresText: "ヘクタール",
    carbonCreditsTitle: "12M",
    carbonCreditsText: "クレジット",
    lockedValueTitle: "$2.3M",
    lockedValueText: "提供された価値",
    registry: "登録簿",
    carbonTitle: "高品質カーボンクレジットに投資",
    agroTitle: "アンチフラジャイルな食料システムに投資",
    tabs: {
      carbon: "カーボンクレジット",
      agroforestry: "アグロフォレストリー"
    }
  },
  projectDetail: {
    changeLocation: "場所を変更",
    projectDesignDocument: "プロジェクト設計書",
    projectFeasibilityReport: "プロジェクト実現可能性報告書",
    developer: "開発者",
    certifiedBy: "認証機関",
    type: "タイプ:",
    state: "都道府県:",
    bid: "入札",
    offeringFinalized: "オファリングが確定しました。",
    offeringCreated: "オファリングが作成されました。",
    participantsWhitelisted: "参加者はホワイトリストに登録されました",
    upcomingOffering: "今後予定されているサービス",
    overview: "概要",
    biodiversity: "生物多様性",
    flora: "フローラ",
    fauna: "ファウナ",
    endangeredAnimals: "絶滅危惧種",
    species: "種",
    files: "書類",
    photos: "写真",
    download: "ダウンロード",
    paused: "「一時停止」",
    offeringPaused: "提供が一時停止されました",
    seeAllPhotos: "すべての写真を見る",
    fileName: "ファイル",
    location: "場所",
    category: "カテゴリ",
    completed: "資金調達完了",
    auditUnsuccesful: "監査失敗",
    cantParticipate: "申し訳ありません。このプロジェクトには参加できません",
    applyToGetRefund: "払い戻しを申請する",
    requestAccepted: "リクエストが承認されました",
    canWithdraw: "今すぐUSDCを引き出すことができます",
    alreadyWithdwan: "引き出された金額",
    withdrawnText: "{usdcAmount} USDCを引き出しました",
    registerForSale: "販売登録",
    fundingCollected: "資金調達済み",
    fundingTarget: "資金調達目標",
    totalAreaHectares: "{project_area_hectares} ヘクタール",
    partner: "パートナー"
  },
  wallet: {
    owned: "所有しているプロジェクト",
    invested: "投資したプロジェクト",
    registered: "登録されたプロジェクト"
  },
  confirmDialog: {
    deleteProjectTitle: "プロジェクトを削除",
    deleteProjectContent: "このプロジェクトを削除してもよろしいですか？",
    deleteDraftTitle: "下書きを削除",
    deleteDraftContent: "「{name}」を削除してもよろしいですか？",
    confirm: "確認",
    cancel: "キャンセル",
    deleteWarning: "この操作は取り消せません。"
  },
  labels: {
    successful: "成功",
    unsuccessful: "失敗",
    startAudit: "監査を開始",
    windowNotOpen: "監査ウィンドウは開いていません",
    auditSuccess: "監査成功",
    cancelUnsuccessful: "失敗した監査をキャンセル",
    days: "日",
    day: "日",
    auditorProjects: "監査人のプロジェクト",
    developerProjects: "開発者プロジェクト",
    developerDrafts: "下書き中のカーボンプロジェクト",
    developerCarbonDrafts: "カーボン資金調達の下書き",
    developerListedCreditDrafts: "上場クレジットの下書き",
    noDeveloperDrafts: "保存された下書きはまだありません。",
    resumeDraft: "下書きを続ける",
    draftStep: "ステップ {step}",
    draftStatus: "ステータス: {status}",
    lastSaved: "{date} に保存",
    addProject: "新しいプロジェクトを作成",
    audits: "監査",
    partnerProjects: "パートナープロジェクト"
  },
  developerPage: {
    hectares: "ヘクタール",
    projectType: "プロジェクトタイプ",
    step1Title: "プロジェクト詳細",
    step2Title: "プロジェクトファイル",
    resultTitle: "結果",
    addProjectFiles: "プロジェクトファイルを追加",
    uploadProjectPhotos: "プロジェクトの写真をアップロード (最大16枚のJPG、JPEG、PNG)",
    uploadForestPhoto: "森林被覆の写真をアップロード (最大1枚のJPG、JPEG、PNG)",
    uploadProjectFiles: "プロジェクトファイルをアップロード (最大4つのPDF)",
    photosUploading: "写真をアップロード中...",
    filesUploading: "ファイルをアップロード中...",
    upload: "アップロード",
    progress: "進捗",
    results: "結果",
    projectData: "プロジェクトデータ",
    noPhotos: "なし",
    images: "画像",
    projectPhotos: "プロジェクトの写真",
    projectFiles: "プロジェクトファイル",
    noFiles: "なし",
    pdfs: "PDFファイル",
    noFileUploaded: "ファイルがアップロードされていません",
    back: "戻る",
    continue: "続ける",
    backToProjectsList: "プロジェクト一覧に戻る",
    finished: "完了!",
    nameForText: "プロジェクト名",
    auditor: "プロジェクト監査人",
    state: "ブラジルの州を選択",
    carbonCreditSupply: "カーボンクレジット供給量",
    listingPrice: "上場価格",
    overview: "概要",
    biodiversity: "生物多様性",
    floraCount: "植物種数",
    faunaCount: "動物種数",
    endangeredSpeciesCount: "絶滅危惧種の数",
    userNotAuthenticated: "ユーザーが認証されていません",
    summary: "プロジェクト概要",
    commission: "開発者USD手数料",
    creditCommission: "開発者カーボンクレジット手数料",
    calcReddCost: "REDD+ コストを計算",
    auditorVerification: "検証監査人",
    auditorValidation: "検証監査",
    projectDeveloper: "プロジェクト開発者",
    projectCertifier: "プロジェクト認証機関",
    selectBrazilState: "ブラジルの州を選択",
    inflationRate: "インフレ率",
    projectCoBenefitors: "プロジェクト共益者",
    landOwner: "土地所有者",
    forestCover: "森林被覆",
    yearsPeriod: "プロジェクトの期間（年）",
    investorsPercent: "投資家 (%)",
    ownersPercent: "所有者 (%)",
    developersPercent: "開発者（％）",
    platformPercent: "プラットフォーム (%)",
    stakersPercent: "ステーカー（%）",
    historicalDeforestationRate: "過去の森林減少率 (0-1)",
    carbonSequestrationRate: "炭素隔離率（トン/年）",
    deforestationDrivers: "森林破壊要因",
    deforestationAgents: "森林破壊の原因",
    ecosystemServicesValuation: "生態系サービスの評価",
    biomeAreaHectares: "バイオーム面積 (ヘクタール)",
    auditorFee: "監査料 (%)",
    auditCost: "監査コスト",
    tokenName: "トークン名",
    tokenSymbol: "トークンシンボル",
    registerAsDeveloper: "開発者として登録",
    numberCarbonCredits: "カーボンクレジット数"
  },
  validation: {
    fieldRequired: "この項目は必須です",
    required: "{field} は必須です。"
  },
  projectStates: {
    projectDesign: "プロジェクト設計",
    validation: "検証",
    registration: "登録",
    monitoring: "モニタリング",
    verification: "認証",
    certifiedEmissionReduction: "発行",
    offering: "オファリング",
    liveOffering: "ライブオファリング",
    finalizedOffering: "最終オファリング",
    audit1: "監査 1",
    audit2: "監査 2",
    audit3: "監査 3",
    audit4: "監査 4",
    audit5: "監査 5",
    audit: "監査",
    projectCycle: "ライフサイクル",
    credits: "クレジット",
    feasibilityAssessment: "実現可能性評価"
  },
  errors: {
    errorEnterName: "名前の欄に入力してください。",
    errorOccrred: "予期しないエラーが発生しました。後でもう一度お試しください。",
    insuffFunds: "ガス代が不足しています。",
    fillRequiredFields: "すべての必須フィールドに入力してください",
    validDate: "DD-MM-YYYY形式の有効な日付を入力してください",
    currentOrEarlierDate: "日付は現在またはそれ以前でなければなりません",
    validEmail: "有効なメールアドレスを入力してください",
    invalidWalletAddress: "無効なイーサリアムアドレスです。確認して再試行してください",
    amountGreaterThanZero: "金額は0より大きくなければなりません",
    failedToRegister: "登録に失敗しました。もう一度お試しください。",
    blacklistedWallet: "ウォレットアドレスはブラックリストに登録されています。サポートに連絡してください。",
    cannotGetContractAddress: "コントラクトアドレスを取得できません。",
    withdrawalFailed: "引き出しに失敗しました。もう一度やり直してください。",
    metamaskNotDetected: "MetaMask拡張機能が検出されません。続行するにはMetaMaskをインストールしてください。",
    metamaskLockedOrOtherWalletActive: "MetaMaskがロックされているか、他のウォレット拡張機能がアクティブです。MetaMaskをアンロックし、他のウォレット拡張機能を無効にしてください。",
    metamaskRequestPending: "MetaMaskで権限リクエストが保留されています。拡張機能を開いて前のリクエストを完了またはキャンセルしてください。",
    connectingMetamask: "MetaMaskへの接続エラー: {message}",
    connectingLedger: "Ledgerへの接続エラー: {message}",
    failedToGetLedgerPublicKey: "Ledgerデバイスから公開鍵を取得できませんでした。",
    transactionCanceled: "取引をキャンセルしました。",
    tokenBurningFailed: "トークンの燃焼に失敗しました",
    tokenWithdrawalFailed: "トークンの引き出しに失敗しました",
    walletBlacklisted: "ウォレットアドレスがブラックリストに登録されています。サポートに連絡してください。",
    updateProjectFailed: "プロジェクトの更新中にエラーが発生しました。",
    uploadPhotosAndDocuments: "進む前に写真と書類をアップロードしてください。",
    selectLocationOnMap: "地図上で場所を選択してください。",
    submitFormFailed: "フォームの送信中にエラーが発生しました。",
    auditorCoverageMissing:
      "この地域のアグロフォレストリー案件に対応する監査人が設定されていません。送信する前に管理者に監査対応範囲を追加してもらってください。",
    obtainProjectIdFailed: "プロジェクトIDの取得に失敗しました。プロジェクトの作成に失敗した可能性があります。",
    uploadFilesOrPhotosFailed: "ファイルまたは写真のアップロード中にエラーが発生しました。",
    selectAtLeastOnePhoto: "少なくとも1枚の写真を選択してください。",
    noCachedPhotos: "キャッシュされた写真が見つかりません。",
    photoUploadFailed: "写真のアップロードが成功しませんでした: {reason}",
    selectAtLeastOneFile: "少なくとも1つのファイルを選択してください。",
    noCachedFiles: "キャッシュされたファイルが見つかりません。",
    fileUploadFailed: "ファイルのアップロードが成功しませんでした: {reason}",
    createProjectFailed: "プロジェクトの作成に失敗しました。",
    walletAddressAlreadyRegistered: "ウォレットアドレスはすでにこのプロジェクトに登録されています",
    auditStartFailed: "監査の開始に失敗しました！",
    auditConfirmFailed: "監査の確認に失敗しました！",
    auditPauseFailed: "監査の一時停止に失敗しました！",
    auditCancelFailed: "不成功な監査をキャンセルできません",
    auditCancelFailedTokens: "失敗した監査をキャンセルできません。トークンはすでに焼却されています",
    cantChangeAllocations: "割り当ての変更にエラーが発生しました。後でもう一度お試しください",
    enterProjectName: "プロジェクト名を入力してください。",
    selectProjectType: "プロジェクトの種類を選択してください。",
    selectState: "州を選択してください。",
    enterAuditorValidation: "検証のために監査人を選択してください。",
    enterAuditorVerification: "確認のために監査人を選択してください。",
    enterForestCoverInfo: "森林被覆に関する情報を入力してください。",
    selectProjectDuration: "プロジェクトの期間（年）を選択してください。",
    enterHistoricalDeforestationRate: "過去の森林減少率を入力してください。",
    enterCarbonSequestrationRate: "炭素隔離率を入力してください。",
    enterDeforestationDrivers: "森林減少の要因を記述してください。",
    enterDeforestationAgents: "森林減少の関与者を一覧で入力してください。",
    enterEcosystemServicesValuation: "生態系サービスの評価を入力してください。",
    enterBiomeArea: "バイオームの面積（ヘクタール）を入力してください。",
    enterProjectArea: "プロジェクトの面積（ヘクタール）を入力してください。",
    selectLandTenureStatus: "土地所有権の状態を選択してください。",
    selectBiome: "バイオームを選択してください。",
    enterProjectGoal: "プロジェクトの概要を入力してください。",
    enterProjectSummary: "プロジェクトの生物多様性に関する情報を入力してください。",
    enterTokenSupply: "トークンの総供給量を入力してください。",
    enterListingPrice: "トークンの上場価格を入力してください。",
    enterTokenName: "トークンの名前を入力してください。",
    enterTokenSymbol: "トークンのシンボルを入力してください（例：ECO）。",
    allocationIsNone: "配分が入力されていません",
    allocationSumTooHigh: "配分の合計が100を超えています",
    allocationSumTooLow: "配分の合計が100未満です",
    addOwnersOrZero: "配分をカバーする所有者を追加するか、所有者の配分を0に設定してください",
    invalidOwnerAllocation: "配分欄に正しい数値を入力してください",
    ownerAllocationTooHigh: "所有者の配分が {percent} を超えています",
    ownerAllocationTooLow: "所有者の配分が {percent} 未満です",
    mintingFailed: "プロジェクトのミントに失敗しました。",
    projectCreationFailed: "プロジェクトの作成中にエラーが発生しました",
    activityNameRequired: "アクティビティ名は必須です。",
    activityIconRequired: "各アクティビティにアイコンを選択してください。",
    activityDescriptionRequired: "説明は必須です。",
    oneSentenceDescription: "ピリオド（。）、感嘆符（！）、または疑問符（？）で終わる1文だけを入力してください。",
    enterAtLeastOneActivity: "続行する前に少なくとも1つのアクティビティを入力してください。",
    selectCertificationNumber: "認証番号を入力してください。",
    selectCertificationBody: "認証機関を入力してください。",
    selectCertificationReport: "認証レポートのURLを入力してください。",
    selectIssuanceDate: "発行日を入力してください。",
    selectCertifier: "認証者を選択してください。",
    auditNotConfirmed: "監査人によって監査が成功と確認されませんでした。",
    filesUploadFailed: "ファイルのアップロードに失敗しました：{response}",
    projectCreateFailed: "プロジェクトの作成に失敗しました。",
    projectIdFailed: "プロジェクトIDの取得に失敗しました。プロジェクト作成が失敗した可能性があります。",
    projectUpdateFailed: "プロジェクトの更新に失敗しました。",
    selectProjectAuditor: "プロジェクトの監査人を選択してください。"
  },
  success: {
    allocationChanged: "割り当てが変更されました",
    registrationReceived: "ご登録のリクエストを正常に受け取りました。ありがとうございました！",
    registeredSuccessfully: "正常に登録されました",
    registeredSuccessfullyMore: "このオファリングの割り当てはすべて満たされています。ただし、現在審査中の他のユーザーが受け入れられなかった場合、リクエストした金額まで割り当てられる可能性があります。",
    withdrawalSuccessful: "引き出しが成功しました！残高が更新されました。",
    tokensBurned: "トークンが正常に燃焼されました",
    tokensWithdrawn: "トークンが正常に引き出されました",
    photosCached: "写真が正常にキャッシュされました。",
    photosUploaded: "写真が正常にアップロードされました。",
    filesCached: "ファイルが正常にキャッシュされました。",
    filesUploaded: "プロジェクトファイルが正常にアップロードされました。",
    projectUpdated: "プロジェクトが更新されました。",
    projectCreated: "データベースにプロジェクトが作成されました。",
    auditStarted: "監査が正常に開始されました！",
    auditConfirmed: "監査が正常に確認されました！",
    auditPaused: "監査が正常に一時停止されました！",
    auditCanceled: "監査が正常にキャンセルされました！"
  },
  scrollTop: {
    scrlTop: "トップへスクロール"
  },
  indexPage: {
    parallax: {
      title1: "高い整合性",
      title2: "ブラジルのカーボンクレジット",
      description: "透明性が高く、信頼でき、気候変動対策のために構築された"
    },
    ourDevelopers: "開発者",
    scalingTitle: "ブラジルにおけるカーボンクレジット市場の変革",
    scalingDescription: "企業と認定された地元のプロジェクトをつなげ、排出量を容易にオフセットし、真の変化をもたらします。完全な透明性とシームレスなアクセスにより、誰もが利益を得ます—これが正しい排出削減です！",
    scalingItem1Title: "50百万",
    scalingItem1Description: "森林破壊から保護されたヘクタール",
    scalingItem2Title: "15%",
    scalingItem2Description: "ブラジルの潜在的な炭素隔離量の割合",
    scalingItem3Title: "$3000億",
    scalingItem3Description: "2050年までの市場ポテンシャル",
    scalingItem4Title: "850万",
    scalingItem4Description: "雇用機会",
    scalingItem5Title: "15倍",
    scalingItem5Description: "10年間での予測成長",
    howWorks: {
      title: "仕組み",
      step: "ステップ",
      itemTitle1: "リモートセンシングと土壌分析",
      itemDescription1: "リモートセンシングと土壌分析データを比較して、カーボンクレジットを計算します。",
      itemTitle2: "トークンとしてのカーボンクレジット",
      itemDescription2: "カーボンクレジットをデジタル化するために、それらをブロックチェーン上のトークンとして発行します。",
      itemTitle3: "スマートコントラクトとしてのオークション",
      itemDescription3: "トークンは、それらに対する入札を受け入れるオークションのスマートコントラクトに送信されます。",
      itemTitle4: "定期的な監査",
      itemDescription4: "資金は特定の年数の間ロックされ、その間、クレジット発行者は各監査が成功した後、資金の一部を請求することができます。",
      descriptionTitle1: "投資保証",
      descriptionTitle2: "保護",
      descriptionText1: "私たちはあなたの投資が完全に保護されていることを保証します。監査が失敗した場合、カーボンクレジットを返却して払い戻しを受けるか、カーボンクレジットのリザーブプールから直接補償を請求することができます—あなたの安全は常に確保されています。",
      descriptionText2: "カーボンクレジットのリザーブプールから直接補償を請求することができます—あなたの安全は常に確保されています。",
      descriptionText: "監査が失敗した場合、カーボンクレジットを返却して払い戻しを受けるか、カーボンクレジットのリザーブプールから直接補償を請求することができます—あなたの安全は常に確保されています。",
      descriptionTitle: "投資が完全に保護されていることを保証します。"
    },
    featuredProjects: {
      title: "注目のプロジェクト",
      seeAll: "すべて見る",
      description: "プロジェクトを紹介したいですか？",
      link: "本日パートナーになるためにご連絡ください"
    },
    testimonials: {
      title: "お客様の声",
      role1: "プロジェクトオーナー",
      role2: "開発者",
      role3: "デザイナー"
    },
    auditsBy: {
      title: "監査者"
    },
    forYou: {
      title: "農家と開発者のために構築",
      tabs: {
        farmers: "農家向け",
        developers: "開発者向け"
      },
      farmers: {
        card1: "衛星で検証された土地登録",
        card2: "面倒な書類なしで資金調達",
        card3: "ウォレットへの直接支払い",
        card4: "農場の拡大と改善のための資金",
        card5: "入金するだけ、支払い計算はすべてお任せ",
        card6: "実際の収穫量に応じて伸びるリターン",
        feature1: "衛星で検証された土地登録",
        feature2: "面倒な書類なしで資金調達",
        feature3: "ウォレットへの直接支払い",
        feature4: "農場の拡大と改善のための資金",
        feature5: "入金するだけ、支払い計算はすべてお任せ",
        feature6: "実際の収穫量に応じて伸びるリターン"
      },
      developers: {
        card1: "新規プロジェクトを数か月ではなく数分で立ち上げ",
        card2: "各ステージに最適化された価格設定を内蔵",
        card3: "プロジェクト書類を自動生成",
        card4: "認証済み投資家にリーチできる内蔵マーケットプレイス",
        card5: "すぐ使える衛星モニタリングと検証",
        card6: "予算管理とファイナンスを一気通貫で",
        feature1: "新規プロジェクトを数か月ではなく数分で立ち上げ",
        feature2: "各ステージに最適化された価格設定を内蔵",
        feature3: "プロジェクト書類を自動生成",
        feature4: "認証済み投資家にリーチできる内蔵マーケットプレイス",
        feature5: "すぐ使える衛星モニタリングと検証",
        feature6: "予算管理とファイナンスを一気通貫で"
      }
    },
    faq: {
      title: "FAQ",
      questionTitle1: "プラットフォームでカーボンクレジットを購入するにはどうすればよいですか？",
      questionDescription1: "プロジェクトのいずれかでカーボンクレジットオファーに登録する必要があります。オファーが開始されると、カーボンクレジットの購入を進めることができる旨の通知メールが届きます。",
      questionTitle2: "カーボンクレジットオファーに登録するにはどうすればよいですか？",
      questionDescription2: "登録するには、次の手順に従ってください:\n• カーボンクレジットプロジェクトのリストがあるプロジェクトページに移動します。\n• 参加したいプロジェクトの「登録」ボタンをクリックします。\n• 会社名、設立日、氏名、ウォレットアドレス、購入希望の配分額などの必要事項を入力します。\n• 登録を送信すると、申請が審査中であることを確認するメールが届きます。チームが詳細を確認し、申請の承認を行います。",
      questionTitle3: "カーボンクレジットオファーに参加するための要件は何ですか？",
      questionDescription3: "カーボンクレジットオファーに参加するには、次のことが必要です:\n• 会社の詳細、ウォレットアドレス、購入希望のクレジット量を提供してプラットフォームに登録します。\n• チームが登録内容を確認し、アカウントが承認されます。\n• 接続されたウォレットに必要なUSDCがあることを確認します。すべての支払いはUSDCを使用したスマートコントラクトで処理されます。\n• 登録プロセスで割り当てられた量以上の入札はできません。",
      questionTitle4: "購入したカーボンクレジットはどこで確認できますか？",
      questionDescription4: "カーボンクレジットの入札に成功し、取引が確認されると、クレジットがウォレットに送られます。これらのクレジットは次の場所で確認できます:\nMetaMaskなどのサポートされているウォレットに接続し、トークン契約アドレスをインポートした後に表示されます。高額取引の場合、セキュリティ向上のためにLedgerウォレットの使用を強くお勧めします。\nダッシュボードページで、割り当てと残りのクレジットがアカウントに表示されます。",
      questionTitle5: "支払い中に銀行振込は可能ですか？",
      questionDescription5: "いいえ、プラットフォームはUSDCトークンによるウォレットを介した支払いのみをサポートしています。銀行振込やフィアット通貨の取引は現在サポートされていません。",
      questionTitle6: "プロジェクトが失敗したかどうかはどこで確認できますか？",
      questionDescription6: "参加したプロジェクトに問題が発生した場合、メールで通知が届きます。また、ダッシュボード上でプロジェクトのステータスが更新されます。",
      questionTitle7: "数年後にプロジェクトが失敗した場合、どうすれば返金を受けられますか？",
      questionDescription7: "監査のいずれかが失敗した場合、購入したカーボンクレジットをスマートコントラクトに返却して返金手続きを開始できます:\n購入したカーボンクレジットをコントラクトに送り返すことができます。そのためには、ウォレットを接続してプロジェクト詳細ページに移動します。監査が失敗した場合、「返金を申請」ボタンが表示されます。このボタンをクリックしてウォレットで取引を確認してください。\nクレジットが受領されると、「引き出し」ボタンが表示されます。このボタンをクリックして取引を確認します。スマートコントラクトはトークンを自動的に焼却し、監査失敗後の残りの期間に比例してUSDCで返金されます（適用される手数料を差し引いた額）。\n返金プロセスの手順については、メールでも通知されます。",
      questionTitle8: "カーボンクレジットのトークン化は法的に認められていますか？",
      questionDescription8: "トークン化はまだブラジルで明確に規制されていませんが、カーボンクレジットの販売は自主的なカーボン市場内で認められています。トークン化はこれらのクレジットの取引を容易にする技術革新であり、その法的受容は環境基準の順守と透明性に依存して、トークン化された資産の有効性を確保します。",
      questionTitle9: "トークン化されたカーボンクレジットの有効性に法的な保証はありますか？",
      questionDescription9: "はい、会社はトークン化されたカーボンクレジットが認定された基準に基づいて検証および確認されていることを保証します。",
      questionTitle10: "トークン化されたカーボンクレジットの真正性と有効性はどのように保証されていますか？",
      questionDescription10: "トークン化されたカーボンクレジットの真正性と有効性は、独立した機関と国際的に認められた基準によって検証され保証されています。さらに、ブロックチェーン技術により、取引の追跡性と不変性が保証され、関係者に対して法的な安全性が向上します。",
      questionTitle11: "ブラジルではカーボンクレジットのトークン化は法的に認められていますか？",
      questionDescription11: "ブラジルでは、カーボンクレジットのトークン化はまだ直接規制されていませんが、ボランタリー市場内ではその使用が認められています。トークン化は、国際的に認められた基準に従って、ブロックチェーン技術を介してこれらの資産の取引と追跡を促進します。"
    },
    ourPartners: "パートナー",
    hectaresBanner: {
      unit: "ヘクタール",
      pipeline: "資金提供済みプロジェクト 124000 ha"
    },
    hero: {
      title: "ブラジルの実体経済を支えるバイオエコノミー事業に投資",
      subtitle: "段階ごとの検証済みマイルストーンと組み込みの資本保護による投資。現地・データドリブン・透明性を備えた設計。",
      exploreProjects: "プロジェクトを見る",
      listProject: "プロジェクトを登録"
    },
    listProjectDialog: {
      title: "プロジェクトを登録",
      subtitle: "次のいずれかを選択",
      connectDeveloper: "デベロッパーとして接続",
      connectFarmer: "農家として接続",
      roleMismatch: "プロジェクトを登録する前に、選択したロールで接続してください。"
    },
    productCards: {
      activeProjectsCount: "{count} 件の進行中プロジェクト",
      loadingProjects: "プロジェクトを読み込み中",
      projectCountUnavailable: "プロジェクトを取得できません",
      carbonCredits: {
        title: "カーボンクレジット",
        description: "ブラジルで現地発行・検証済みのカーボンクレジット。発行時にトークン化し、透明で効率的な取引と償却を実現。",
        activeProjects: "12 件の進行中プロジェクト"
      },
      agroforestry: {
        title: "アグロフォレストリー",
        description: "気候変動に強い農業システムで、同じ土地に複数の作物を組み合わせ、長期的に安定した収量と USDC でのキャッシュフロー収益を提供。",
        activeProjects: "12 件の進行中プロジェクト"
      }
    },
    whyInvest: {
      title: "なぜ Brazil Carbon に投資するのか",
      tabs: {
        agroforestry: "アグロフォレストリー",
        carbonCredits: "カーボンクレジット"
      },
      agroforestry: {
        feature1: "気候変動・干ばつに強い農業システム",
        feature2: "同じ土地で複数の作物（カカオ、アサイー、コーヒー、クプアス）",
        feature3: "USDC で支払われるキャッシュフロー収益",
        feature4: "土壌の健康向上による長期コスト削減",
        feature5: "単一栽培より長期的に安定して収益性が高い",
        feature6: "生物多様性を守りながら収益を生む"
      },
      carbonCredits: {
        feature1: "認証済みブラジル発プロジェクトからの検証済みクレジット",
        feature2: "透明で効率的な取引のためオンチェーンでトークン化",
        feature3: "マイルストーン検証付きのステージ別資本リリース",
        feature4: "スマートコントラクトによる投資家保護を内蔵",
        feature5: "第三者による定期監査で継続的な説明責任",
        feature6: "成長するブラジルの自主的炭素市場への直接アクセス"
      }
    },
    howItWorksNew: {
      title: "仕組み",
      step1: {
        title: "プロジェクトはステージで構成",
        subtitle: "各ステージは次に進む前に完了・検証される必要があります。"
      },
      step2: {
        title: "検証後にのみ資本が解放される",
        subtitle: "マイルストーンを達成した場合にのみ資金が前進。"
      },
      step3: {
        title: "資産または収益は透明に分配される",
        subtitle: "カーボンクレジット、収量、キャッシュフローはオンチェーンで配布。"
      }
    },
    ecosystem: {
      title: "私たちのエコシステム",
      investInProjects: {
        title: "プロジェクトに投資",
        description: "検証済みのバイオエコノミープロジェクトに直接投資し、各ステージの進捗を追跡。",
        cta: "プロジェクトを見る"
      },
      bctToken: {
        title: "BCT トークン",
        description: "BCT をロックしてコミュニティに参加し、実際のカーボンクレジットとアグロフォレストリー収益に連動した報酬を獲得。",
        cta: "詳しく見る"
      },
      reforestationGame: {
        title: "再植林ゲーム",
        description: "プレイヤーが生態系を回復させ、炭素隔離について学び、参加報酬を獲得する教育用アイドルゲーム。",
        cta: "プレイする",
        comingSoon: "近日公開"
      }
    },
    roadmap: {
      title: "ロードマップ",
      q3_2025: "トークン化されたカーボンクレジット投資、資金調達を開始したアグロフォレストリープロジェクト、許可制のセカンダリー取引市場。",
      q4_2025: "マルチソースのカーボンクレジット算定（衛星＋現地調査区＋生態系シミュレーション）、開発者向けのエンドツーエンドのプロジェクト掲載、段階ゲート方式の投資家資本保護。",
      q1_2026: "独立監査人のワークフローとコンソール、投資家リターンシミュレーター、承認ゲート付きの開発者パイプライン。",
      q2_2026: "リアルタイムのプロジェクト価格設定エンジン、プロジェクトのタイムラインおよびコスト計算エンジン、KYC 認証済み投資家のオンボーディング、プラットフォームトークンとステーキング。",
      q3_2026: "自動生成されるプロジェクト文書（PDD）、方法論の選択・生成ワークフロー、複数の認証機関との直接統合、本番環境での初のトークン化クレジット発行。",
      q4_2026: "ハードウェアによる証明付きバイオチャークレジット生成、エネルギークレジットのトークン化、地域コミュニティ型アグロフォレストリー投資パイロット、TradFi の法定通貨↔デジタル資産オン／オフランプ、トークン化された実世界資産のセカンダリー取引。"
    },
    faqNew: {
      title: "よくある質問",
      q1: {
        title: "どのように投資できますか？",
        answer: "プロジェクトページから案件を選び、投資をクリックします。ウォレットを接続し、USDC で投資します。"
      },
      q2: {
        title: "投資に必要なものは？",
        answer: "USDC を保有するデジタルウォレットが必要です。将来の受け取り時には KYC が必要になります。"
      },
      q3: {
        title: "投資状況はどこで確認できますか？",
        answer: "ダッシュボードとサイドパネルで、すべての資産を確認できます。"
      },
      q4: {
        title: "銀行振込は使えますか？",
        answer: "現在は USDC のみ対応しています。将来的に法定通貨対応を予定しています。"
      },
      q5: {
        title: "プロジェクトが失敗した場合は？",
        answer: "プロジェクトページに表示され、請求ボタンが表示されます。"
      },
      q6: {
        title: "払い戻しはどうなりますか？",
        answer: "未使用資金がある場合、トークンを返却することで返金を受けられます。"
      },
      q7: {
        title: "アグロフォレストリーとは？",
        answer: "樹木と作物を組み合わせた農業で、安定した収益と環境保全を両立します。"
      },
      q8: {
        title: "収益はどこから生まれますか？",
        answer: "農産物販売後の収益が USDC で分配されます。"
      }
    }
  },
  projectsGrid: {
    type: "タイプ",
    learnMore: "詳しく学ぶ",
    biddingClosed: "入札終了",
    biddingOpen: "入札受付中",
    upcomingOffer: "今後のオファー",
    by: "〜によって",
    totalCreditsOffered: "提供されたクレジットの合計",
    certificate: "証明書"
  },
  notFound: {
    title: "申し訳ありません、このページは存在しません",
    description: "あちこち探しましたが、お探しのものは見つかりませんでした。もっと良い場所を見つけましょう。",
    returnHome: "ホームに戻る",
    getHelp: "サポートを受ける"
  },
  dashboardPage: {
    publicSale: "パブリックセール",
    withdrawCredits: "クレジットを引き出す",
    investment: "投資",
    profit: "利益",
    registered: "登録済み",
    invested: "投資済み",
    owned: "所有",
    creditsSold: "販売されたクレジット",
    myAllocation: "私の割り当て",
    myCredit: "私のクレジット",
    projects: "プロジェクト",
    registeredInvestors: "登録された投資家",
    cardonCredit: "カーボンクレジット",
    projectStage: "プロジェクト段階",
    totalProjects: "合計プロジェクト数",
    seeProjectDetails: "詳細を見る",
    fundRaised: "調達された資金",
    creditSold: "購入したクレジット",
    nextAudit: "次の監査",
    projectEnded: "プロジェクト終了",
    unlockedFunds: "アンロックされた資金",
    nextUnlock: "次のアンロック",
    balance: "残高",
    contract: "契約",
    offsetting: "オフセット",
    fundsRaised: "調達された資金",
    nextAuditL: "次の監査",
    paidAmount: "支払金額",
    creditsAllocated: "割り当てられたクレジット",
    expectedROI: "予想ROI",
    investedStage: "投資済みステージ",
    fundingStage: "資金調達ステージ"
  },
  carbonCycle: {
    offering: "オファリング",
    registration: "登録",
    live: "ライブ",
    ended: "終了",
    projectDevelopment: "プロジェクト開発",
    certification: "認証",
    audit: "監査"
  },
  guidePage: {
    fullVideo: "フルビデオ",
    rootBreadcrumb: "ブラジルカーボン ヘルプセンター",
    howHelp: "どのようにお手伝いできますか？",
    askQuestion: "質問をする"
  },
  multiSig: {
    alreadyApproveWithdraw: "引き出しをすでに承認しています",
    alreadyApproveStartAudit: "監査の開始をすでに承認しています",
    alreadyApproveAuditSuccess: "監査の成功をすでに承認しています",
    alreadyApproveAuditUnsuccess: "監査の不成功をすでに承認しています",
    alreadyApproveCancelUnsuccess: "不成功の監査のキャンセルをすでに承認しています",
    waitingApprove: "他の署名者の承認待ちです",
    withdrawalOwnerSuccessful: "引き出し成功！オーナーの残高が更新されました。",
    withdrawalDeveloperSuccessful: "引き出し成功！開発者の残高が更新されました。",
    withdrawalPartnerSuccessful: "引き出し成功！パートナーの残高が更新されました。"
  },
  auditorPage: {
    audits: "監査",
    inProgress: "進行中",
    successfull: "成功",
    unsuccessful: "不成功"
  },
  newDashboard: {
    ownedProjects: "保有中のプロジェクト",
    allTokens: "すべてのトークン",
    cardonCredit: "カーボンクレジット",
    totalProjects: "総プロジェクト数",
    projectsOwned: "所有プロジェクト",
    projects: "プロジェクト",
    assets: "資産",
    investments: "投資"
  },
  newCard: {
    certificationBody: "認証機関",
    certificateId: "証明書ID",
    issuanceDate: "発行日",
    creditsOwned: "保有クレジット",
    certificationReport: "認証レポート",
    learnMore: "詳細を見る",
    sell: "販売",
    claim: "請求",
    claimBenefit: "給付を請求",
    benefitClaimSuccess: "給付を請求しました",
    benefitClaimError: "給付の請求に失敗しました",
    availableToClaim: "請求可能"
  },
  sellForm: {
    selectYear: "年を選択してください",
    unitPrice: "単価",
    owned: "所有",
    putOnSale: "販売に出す",
    enterCreditsAmount: "クレジット数を入力",
    carbonCredits: "カーボンクレジット",
    agroProducts: "アグロフォレストリー製品",
    creditsAvailable: "利用可能なクレジット",
    sell: "販売",
    cancel: "キャンセル",
    listedOnSaleSuccess: "販売リストに追加",
    listedOnSaleError: "販売リスト登録エラー"
  },
  saleSideContainer: {
    buyText: "{showAmount} {symbol} を購入しました。",
    seeTransaction: "取引を確認",
    buyText2: "{name} の購入が成功しました。",
    backToBuy: "購入画面に戻る",
    selectYear: "年を選択",
    noTokensAvailable: "販売可能なトークンはありません",
    buyVintageCredits: "ヴィンテージクレジットを購入",
    buyCredits: "クレジットを購入",
    enterUsdcAmount: "の金額を入力",
    usdcAvailable: "{amount} USDC 利用可能",
    usdc: "USDC",
    carbonCredit: "カーボンクレジット",
    AgroforestryProducts: "アグロフォレストリー製品",
    loginToBuy: "クレジットを購入するにはログインしてください",
    insufficientFunds: "残高不足",
    buy: "購入",
    vintage: "ヴィンテージ",
    buyCarbonCredits: "カーボンクレジットを購入する",
    batch: "バッチ",
    saleClosed: "販売終了",
    saleClosedText: "申し訳ありませんが、販売期間が終了しました。"
  },
  investSideContainer: {
    investmentClosed: "投資は終了しました",
    agroQuestionTooltip: "推定アグロフォレストリー製品からUSDCへの換算レート",
    questionTooltip: "推定クレジットから実際に発行されたクレジットへの換算率",
    creditsToClaim: "{amount} クレジットを請求できます！",
    usdcToClaim: "{amount} USDCを請求できます！",
    invest: "投資する",
    loginAgain: "ログイン",
    sessionExpired: "セッションの有効期限が切れました。続行するにはログインしてください。",
    investmentUnavailable:
      "現在、投資を一時的にご利用いただけません。後でもう一度お試しいただくか、問題が続く場合はサポートにお問い合わせください。",
    roi: "{percentage}% ROI",
    certification: "認証",
    enterUsdcAmount: "の金額を入力",
    usdcAvailable: "{amount} USDC 利用可能",
    usdc: "USDC",
    carbonCredit: "カーボンクレジット",
    agroforestryProducts: "アグロフォレストリー製品",
    insufficientFunds: "残高不足",
    investText: "{showAmount} {symbol} を投資しました。",
    seeTransaction: "取引を確認",
    investText2: "{name} への投資が成功しました。",
    backToInvest: "投資画面に戻る",
    claimCredits: "クレジットを請求",
    youReceived: "{showAmountExchange} {symbol} を受け取りました",
    exchangeSuccess: "カーボンクレジットの交換に成功しました。",
    close: "閉じる",
    rate: "レート",
    credits: "クレジット",
    enterAmountUSDCWarning: "最初にUSDCの金額を入力してください",
    enterAmountCreditWarning: "最初にクレジット数を入力してください",
    enterAmountAgroWarning: "最初にアグロフォレストリーの数量を入力してください"
  },
  overviewTab: {
    satelliteView: "衛星ビュー",
    plantingArea: "植栽面積",
    visitMethodologyWebsite: "方法論のウェブサイトを見る",
    description: "説明",
    coBenefitors: "共同受益者",
    forestCoverMap: "森林被覆マップ",
    forestVisualizer: {
      unavailable: "年間衛星観測を利用できません。",
      yearToDate: "年初来",
    },
    developers: "開発者",
    developedBy: "開発者",
    certifiedBy: "認証者",
    files: "ファイル",
    fileName: "ファイル",
    location: "所在地",
    projectSize: "プロジェクトの規模",
    forestCover: "森林被覆",
    methodologyApprovedBy: "承認された方法論",
    hectares: "ヘクタール",
    hectare: "ヘクタール",
    methodology: "方法論",
    projectArea: "プロジェクト面積",
    partners: "パートナー",
    notCalculatedYet: "未計算",
    metrics: {
      project_area_ha: "プロジェクト面積",
      land_tenure_status: "土地所有権",
      crediting_period_years: "モデリング期間",
      methodology_code: "方法論",
      removal_pathway: "除去経路",
      country_iso: "国",
      credit_schedule_label: "クレジットスケジュール",
      methane_abatement_activity: "排出削減活動",
      community_service_type: "サービス種別",
      energy_asset_activity: "資産 / 活動",
    },
    metricValues: {
      years: "{count}年",
    },
    landownerCompensation: {
      title: "土地所有者補償",
      included: "投資家負担の土地所有者・共同受益者補償が、独立したプロジェクトコストとして含まれています。",
      cap: "最大予算",
      monthly: "月額",
      months: "月数",
      payoutStart: "支払い開始",
      allocation: "配分",
      projectStart: "プロジェクト開始",
      afterStage: "{year}年目 {stage} の後",
      allocationUniform: "ステージに配分",
      allocationUpfront: "前払いエスクロー",
      refundPolicy: "発生済み補償は返金不可の運営費です。未発生の将来補償は、プロジェクト失敗時の返金方針に従って返金対象として残ります。"
    }
  },
  environmentTab: {
    biodiversityDescription: "この地域の種の豊かさと多様性における順位を反映しています。",
    biodiversityScore: "生物多様性\n指数",
    preventedDeforestation: "防止された森林破壊\n（ヘクタール/年）",
    ecosystemServicesValue: "生態系サービス\nの価値:",
    carbonSequestration: "炭素隔離の可能性\n（トン/年）",
    deforestationCauses: "森林破壊の\n原因",
    deforestationContributors: "森林破壊の\n要因",
    current: "現在",
    forestCover: "森林被覆",
    metrics: {
      current_biomass_t: "現在のバイオマス",
      biomass_uncertainty_pct: "バイオマスの不確実性",
      total_credits_forecast_tco2e: "総クレジット予測",
      prevented_deforestation_ha_yr: "回避された森林減少",
      avg_avoided_credits_forecast_tco2e_yr: "回避クレジット / 年",
      total_co2_sequestration_forecast_tco2e: "隔離予測",
      avg_annual_sequestration_forecast_tco2e: "隔離量 / 年"
    }
  },
  carbonTab: {
    collectingFunds: "募集中",
    totalCarbonCredits: "総カーボンクレジット",
    finalCarbonCreditPrice: "最終カーボンクレジット\n価格",
    totalCarbonCreditValuation: "総カーボンクレジット\n評価額",
    investmentPrices: "カーボンクレジットの投資価格はステージによって異なります:",
    filled: "完了",
    future: "未来",
    currentPhase: "現在のフェーズ",
    current: "現在",
    currentStage: "現在のステージ",
    invest: "投資する",
    priceText: "価格",
    costText: "コスト",
    roiText: "ROI"
  },
  investmentTab: {
    pricePerKilo: "1キロあたりの価格",
    additionalRevenue: "追加収益の合計",
    fundingRequirements: "資金要件:",
    roi: "{value}% ROI",
    stageCostBreakdown: "ステージコストの内訳",
    otherCosts: "その他",
    baseCostBreakdown: "基本コストの内訳",
    roiWithCost: "{roi}% ROI ${cost}",
    filled: "完了",
    future: "未来",
    currentPhase: "現在のフェーズ",
    currentStage: "現在のステージ"
  },
  roiChart: {
    inflation: "インフレーション",
    total: "合計",
    cumulative: "累積ROI"
  },
  auditCardNew: {
    audit: "監査",
    years: "年",
    year: "年",
    stageForAudit: "監査のステージ",
    startStage: "{stageName} を開始",
    noStageName: "ステージ名なし",
    unsuccessful: "失敗",
    successful: "成功",
    auditWindowOpen: "監査ウィンドウが開いています",
    actionRequired: "対応が必要です",
    acceptAssignment: "割り当てを承認",
    releaseFunds: "資金を解放",
    lifecycleActions: "監査ライフサイクル操作",
    action: "操作",
    stage: "ステージ",
    submitAction: "操作を準備して署名",
    actionCompleted: "監査操作が完了しました。",
    amount: "数量",
    claimId: "請求 ID（bytes32）",
    evidenceHash: "証拠ハッシュ（bytes32）",
    bindingHash: "バインディングハッシュ（bytes32）",
    planHash: "プランハッシュ（bytes32）",
    payee: "補償受取人",
    yearValues: "年（カンマ区切り）",
    stageIndexes: "ステージ番号（カンマ区切り）",
    allocations: "配分（カンマ区切り）",
    cap: "補償上限",
    seriesId: "シリーズ ID",
    amountWhole: "発行する整数クレジット",
    creditsWhole: "確定する整数クレジット",
    registryId: "レジストリ ID",
    vintageYear: "ビンテージ年",
    hostCountry: "ホスト国（bytes2）",
    capWhole: "整数クレジット上限",
    registryReference: "レジストリのクレジット参照または URL",
    routeReference: "方法論または資産ルートの参照",
    creditEvidenceReference: "認証証拠の URL または参照",
    confirmProjectFailure:
      "このプロジェクトを失敗として確定すると元に戻せないことを理解しました。",
    creditIssuance: {
      title: "クレジット発行 — {year}年目",
      yearBadge: "{year}年目",
      certifier: "認証機関",
      methodology: "方法論",
      certifiedCredits: "発行量（整数 tCO₂e）",
      predictedCredits: "予測値 {credits} tCO₂e を入力済みです。シリーズ作成前に編集できます。",
      referencePlaceholder: "URL、参照、または既存の 0x ハッシュを貼り付け",
      referenceHelp: "この発行に対応する公開認証記録またはレジストリ記録を使用してください。",
      registryIdHelp: "外部 ID 全体を入力してください。コンパクトなオンチェーン ID は自動生成されます。",
      registryIdRequired: "外部レジストリまたは証明書 ID を入力してください。",
      wholeCreditsRequired: "正の整数クレジット量を入力してください。",
      exceedsSeriesCap: "シリーズ上限を超える量は指定できません。",
      registryEvidenceRequired: "発行前にレジストリ ID と認証記録を入力してください。",
      evidenceReferenceRequired: "認証証拠の URL、参照、または既存のハッシュを入力してください。",
      descriptions: {
        verifiedCreditSeriesCreate: "証拠を確認してオンチェーンシリーズを作成します。",
        creditBindingApproval: "このプロジェクト年度のシリーズ紐付けを承認します。",
        verifiedCreditIssue: "検証済みクレジットを決済保管先へ発行します。",
        creditYearFinalize: "請求開始日に投資家が請求できるよう年度を確定します。"
      }
    },
    confirmedBlock: "ブロック {block} で確認済み",
    mode: {
      auditor_required: "監査人ウォレットによる手動操作",
      backend_api: "接続済み監査 API",
      onchain: "オンチェーン監査コントラクト"
    },
    modeStatus: {
      auditor_required: "割り当てられた監査人ウォレットが必要です。",
      backend_api:
        "接続済み監査サービスが操作を送信します。ブラウザ署名は無効です。",
      onchain:
        "監査コントラクトがオンチェーンで操作を送信します。ブラウザ署名は無効です。"
    },
    actions: {
      stageRelease: "ステージ元本を解放",
      projectFailure: "プロジェクトを失敗として確定",
      stageRefundFinalize: "ステージ返金を確定",
      compensationPlanConfigure: "補償プランを設定",
      compensationAccrual: "ステージ補償を計上",
      compensationStop: "補償を停止",
      creditBindingApproval: "クレジット紐付けを承認",
      verifiedCreditSeriesCreate: "検証済みクレジットシリーズを作成",
      verifiedCreditIssue: "検証済みクレジットを発行",
      creditYearFinalize: "クレジット年度を確定"
    },
    releaseStage: "{year}年目・ステージ{stage}",
    waitingForFundedStage: "資金調達済みステージを待っています。",
    waitingForDeveloperWithdrawal: "開発者による解放済み資金の出金を待っています。",
    loadingStatus: "監査状況を読み込み中…",
    preparingAction: "ウォレット操作を準備中…",
    actionUnavailable: "監査操作は一時的に利用できません。",
    auditorLoginRequired: "割り当てられた監査人ウォレットでログインしてください。",
    assignmentAccepted: "監査人の割り当てを承認しました。",
    fundsReleased: "開発者の出金用にステージ資金を解放しました。",
    actionPendingVerification: "トランザクションを送信しました。状態を更新中です。",
    insufficientGasFunds:
      "この監査操作のネットワーク手数料を支払うための ETH がウォレットに不足しています。",
    actionFailed: "監査操作を完了できませんでした。もう一度お試しください。"
  },
  AuditorPageNew: {
    inProgress: "進行中",
    successful: "成功",
    unsuccessful: "失敗",
    auditedProjects: "監査済みプロジェクト",
    activeAudits: "進行中の監査",
    waitingAuditWindow: "監査期間待ち",
    completedAudits: "完了した監査",
    connectTitle: "監査人ウォレットを接続",
    connectDescription:
      "管理者が登録したウォレットを接続すると、割り当てられたプロジェクトを確認し、監査アクションに署名できます。",
    connectWallet: "監査人ウォレットを接続",
    connectHint:
      "監査人レコードに設定されたものと同じウォレットアドレスを使用してください。",
    connectNotRegistered:
      "このウォレットまたはメールアドレスは監査人として登録されていません。管理者に監査人レコードの追加を依頼してから、もう一度お試しください。"
  },
  optionTabs: {
    overview: "概要",
    environment: "環境",
    status: "ステータス",
    activities: "活動内容",
    investment: "投資",
    yield: "収穫量",
    financials: "財務"
  },
  stageNames: {
    design: "デザイン",
    validation: "検証",
    monitoring: "モニタリング",
    verification: "確認",
    issuance: "発行",
    certification: "認証",
    community: "コミュニティ"
  },
  projectUsersStep: {
    title: "プロジェクトユーザー",
    owners: "所有者",
    addOwner: "所有者を追加",
    removeOwner: "削除",
    name: "名前",
    walletAddress: "ウォレットアドレス",
    allocation: "配分（％）",
    coBenefitors: "共同受益者",
    addBenefitor: "受益者を追加",
    allocationOfCredits: "カーボンクレジットの配分",
    landTenureStatus: "土地保有状況",
    landOwnershipStatus: "土地所有権の状況",
    landOwnershipPlaceholder: "権利区分を選択",
    landOwnershipHelper: "ブラジルの土地保有慣行（CCIR/登記、占有、入植地、先住民土地、キロンボーラ、保全区域、コンセッション）に基づく追加項目です。",
    landStatusOptions: {
      "0": "公有",
      "1": "私有",
      "2": "コンセッション",
      private_title: "私有",
      possession: "占有（非公式）",
      agrarian_settlement: "農地改革入植地",
      indigenous_territory: "先住民土地",
      quilombola: "キロンボーラ共同体",
      conservation_unit: "保全区域（RPPN、APA など）",
      forest_concession: "森林コンセッション",
      other: "その他（記入）"
    },
    biome: "バイオーム",
    biomeOptions: {
      "0": "アマゾン熱帯雨林",
      "1": "カアチンガ",
      "2": "セラード",
      "3": "大西洋岸森林",
      "4": "パンタナル",
      "5": "パンパ"
    }
  },
  createInvestForm: {
    investmentCreated: "投資が正常に作成されました",
    basicInfo: "基本情報",
    commissions: "手数料（％）",
    usdcFee: "USDC手数料",
    costs: "コスト",
    year: "{year}年",
    supply: "供給量",
    finalPrice: "最終価格",
    uploadPhoto: "森林被覆写真をアップロード（最大1枚、JPG、JPEG、PNG）",
    design: {
      title: "設計",
      cost: "設計コスト",
      description: "設計の説明"
    },
    validation: {
      title: "バリデーション",
      cost: "バリデーションコスト",
      description: "バリデーションの説明"
    },
    monitoring: {
      title: "モニタリング",
      cost: "モニタリングコスト",
      description: "モニタリングの説明"
    },
    verification: {
      title: "検証",
      cost: "検証コスト",
      description: "検証の説明"
    },
    issuance: {
      title: "発行",
      cost: "発行コスト",
      description: "発行の説明"
    },
    navigation: {
      close: "閉じる",
      back: "戻る",
      continue: "続行",
      createInvest: "投資を作成"
    },
    startInvestmentProcess: "投資プロセスを開始"
  },
  errorMessages: {
    missingTotalSupply: "年 {year} の有効な総供給量を入力してください。",
    missingFinalPrice: "年 {year} の有効な最終価格を入力してください。",
    totalSupplyExceeded: "総供給量がプロジェクトの供給量を超えてはいけません。最大許容値: {max}。",
    missingDescription: "年 {year} の {field} の説明を入力してください。",
    missingForestPhoto: "年 {year} の森林被覆写真をアップロードしてください。",
    enterValidCosts: "すべてのステージに0より大きい有効なコストを入力してください"
  },
  forestCover: {
    "1": "熱帯雨林",
    "2": "熱帯乾燥林",
    "3": "山地雲霧林（モンターヌフォレスト）",
    "4": "大西洋岸森林（アトランティック・フォレスト）",
    "5": "亜熱帯林",
    "6": "マングローブ林",
    "7": "洪水林（バルゼアとイガポ）",
    "8": "サバンナと森林のモザイク地帯",
    "9": "温帯林",
    Dense: "熱帯雨林"
  },
  landStatus: {
    "0": "公有",
    "1": "私有",
    "2": "コンセッション"
  },
  activitiesSection: {
    activity: "アクティビティ",
    addActivity: "アクティビティを追加",
    updateActivities: "アクティビティを更新",
    activityNamePlaceholder: "アクティビティ名",
    descriptionPlaceholder: "説明",
    save: "保存"
  },
  developerWithdrawal: {
    available: "出金可能な資金があります",
    stage: "{year}年目・ステージ{stage}",
    description: "認証者がこのステージの元本をプロジェクト開発者に解放しました。",
    withdraw: "出金",
    success: "資金を出金しました。",
    pending: "トランザクションを送信しました。出金状況を更新中です。",
    failed: "出金を完了できませんでした。もう一度お試しください。",
    unavailable: "出金は一時的に利用できません。しばらくしてからもう一度お試しください。"
  },
  stageActions: {
    sign: "{stage}に署名",
    withdraw: "{stage}から出金",
    withdrawalPendingApproval: "出金承認待ち"
  },
  signDialog: {
    investmentProcessFinished: "プロジェクトの投資プロセスは完了しました",
    stageRequiresAudit: "最初にステージ {stage} の監査が必要です",
    stageRequiresDeveloper: "このステージには開発者である必要があります",
    stageRequiresAuditor: "このステージには監査人である必要があります",
    stageRequiresCertifierOrDeveloper: "このステージには {role} である必要があります",
    certifier: "認証者",
    developer: "開発者",
    stageNotCompleted: "ステージが完了していません",
    withdrawSuccess: "出金が成功しました",
    signError: "署名中にエラーが発生しました",
    remoteSensingImageHash: "リモートセンシング画像のハッシュ",
    reportHash: "レポートのハッシュ",
    deforestationRateM2: "森林伐採率 (m²)",
    landDegradationRateM2: "土地劣化率 (m²)",
    abovegroundCarbonStockKg: "地上部炭素蓄積量 (Kg)",
    belowgroundCarbonStockKg: "地下部炭素蓄積量 (Kg)",
    soilOrganicCarbonStockKg: "土壌有機炭素蓄積量 (Kg)",
    deadOrganicMatterKg: "枯死有機物量 (Kg)",
    landUseOpportunityCost: "土地利用の機会費用",
    leakageKg: "リーケージ (Kg)",
    verifierName: "検証者の氏名",
    verifierLicense: "検証者のライセンス",
    verificationReportHash: "検証レポートのハッシュ",
    verifiedEmissionReductionsKg: "検証された排出削減量 (Kg)",
    verificationDate: "検証日",
    certificationBody: "認証機関",
    certificationNumber: "認証ID",
    certificationReport: "認証レポートURL",
    creditsIssued: "発行されたクレジット数",
    issuanceDate: "発行日",
    creditSerialStart: "クレジットのシリアル開始",
    creditSerialEnd: "クレジットのシリアル終了",
    certificationStage: "認証ステージ",
    required: "この項目は必須です",
    invalidNumber: "有効な数値を入力してください",
    invalidDate: "有効な日付を入力してください",
    signed: "ステージが正常に署名されました",
    withdrawn: "ステージが正常に出金されました",
    updated: "ステージが正常に更新されました",
    saved: "ステージデータが保存されました",
    errorOnWithdraw: "出金を完了できませんでした。もう一度お試しください。",
    withdrawUnavailable: "出金は一時的に利用できません。しばらくしてからもう一度お試しください。"
  },
  investmentCostsStruct: {
    validation: {
      _label: "検証コスト",
      field_visit: "現地訪問",
      satellite_analysis: "衛星分析",
      "3rd_party_validation": "第三者検証",
      "legal_&_admin": "法務・管理",
      certifier_registration: "認証機関登録",
      registration_fee: "登録料"
    },
    monitoring: {
      _label: "モニタリングコスト",
      travel: "移動費",
      "accommodation_&_meals": "宿泊と食事",
      personnel: "人件費",
      data_processing: "データ処理"
    },
    verification: {
      _label: "検査コスト",
      "site_visit_&_field_audit": "現地訪問とフィールド監査",
      "report_submission_&_compliance": "報告書提出とコンプライアンス",
      "legal_&_admin": "法務・管理"
    },
    issuance: {
      _label: "発行コスト",
      verification_review: "検証レビュー",
      carbon_credit_issuance_fee: "カーボンクレジット発行手数料",
      annual_fee: "年会費",
      insurance: "保険",
      submission_fee: "提出料"
    }
  },
  stageNamesAbr: {
    design: "設計",
    validation: "検証",
    monitoring: "監視",
    verification: "確認",
    issuance: "発行",
    certification: "発行",
    finalPrice: "最終価格"
  },
  agroStageNamesAbr: {
    planning: "計画",
    site_preparation: "準備",
    planting: "植付",
    maintenance: "管理",
    harvest: "収穫",
    value_addition: "付加価値",
    marketing: "マーケ.",
    finalPrice: "最終価格",
    cultureCost: "コスト"
  },
  developerForm: {
    full_name: "氏名",
    email: "メールアドレス",
    web_page: "ウェブページ",
    company_registry_number: "法人登録番号",
    date_of_incorporation: "設立日",
    phone: "電話番号",
    wallet_address: "ウォレットアドレス",
    logo: "会社のロゴ"
  },
  tokenPage: {
    fifthSectionCta: "ファーミングを開始",
    tokenSupply: "トークン供給量",
    tokenAmount: "850M",
    projectSize: "現在のプロジェクト面積（ヘクタール）",
    projectAmount: "32",
    sequestrationRate: "1トークンあたりの炭素隔離率",
    sequestrationAmount: "124000 ha",
    sequesterSecondLine1: "BCTをロックし、CO₂を捕捉し、",
    sequesterSecondLine2: "現実世界の収益を受け取る。",
    hero: {
      title: "CO₂を育ててカーボンクレジットと\nアグロフォレストリートークンを獲得",
      stake: "CO2を育てる",
      grow: "森を育てる"
    },
    thirdSection: {
      title: "仕組み",
      gridTitle1: "1",
      gridTitle2: "2",
      gridTitle3: "3",
      gridTitle4: "4",
      gridDescription1: "BCTトークンを購入してロックし、報酬を獲得",
      gridDescription2: "トークン資金は認証されたプロジェクトに投資されます。",
      gridDescription3: "森林がCO₂を吸収してカーボンクレジットを生成し、農林業はカカオやアサイーを生産",
      gridDescription4: "カーボンクレジットとアグロトークンを受け取り、USDCに変換可能"
    },
    secondSectionTitle: "インタラクティブな森林シミュレーション",
    secondSectionDescription: "50種以上のアマゾン樹木で森を育て、バイオマスや生物多様性を高め、希少種をアンロックしてリワードを最大化しよう。",
    earningModelTitle: "収益モデルとリスク保護",
    earningModel: {
      item1Title: "実物資産の裏付け",
      item1Description: "土地とアグロフォレストリー製品",
      item2Title: "継続的な収益ストリーム",
      item2Description: "カーボンクレジットが秒単位で配信される",
      item3Title: "APRの上昇",
      item3Description: "拡大する資産ベースに連動"
    },
    sixthSectionTitle: "インタラクティブな森林シミュレーション",
    sixthSectionDescription: "「最高！ 植物に疎かったけど今は森林の知識がついた！」"
  },
  transactionActions: {
    invest: "投資する",
    buy: "購入",
    sell: "売却",
    claim: "請求"
  },
  agroStageNames: {
    planning: "計画と設計",
    site_preparation: "サイト準備",
    planting: "植栽と定着",
    maintenance: "維持管理",
    harvest: "収穫と収穫後処理",
    value_addition: "付加価値の創出",
    marketing: "マーケティングと流通",
    labor: "労働力",
    inputs: "投入資材",
    tools: "道具・設備",
    services: "サービス・コンサルタント",
    infrastructure: "インフラ",
    design: "デザイン",
    validation: "検証",
    monitoring: "モニタリング",
    verification: "確認",
    issuance: "発行",
    certification: "認証",
    cultureCost: "特定コスト"
  },
  agroCarbonTab: {
    revenueGrowth: "収益の成長",
    yoyGrowthRate: "前年比成長率（YoY）",
    totalProduce: "総生産量",
    currentProduction: "現在の生産量",
    inKg: "年間あたりのキログラム単位",
    sellingPricePerKg: "1Kgあたりの販売価格",
    production: "生産量"
  },
  farmerPage: {
    selectSpeciesYear: "樹種と年を選択してください",
    selectSpecies: "樹種を選択してください",
    selectYear: "年を選択してください",
    selectedYear: "選択した年",
    depositFor: "預け入れ先",
    finalizeDepositFor: "預け入れ確定先",
    enterDepositAmount: "入金額を入力してください",
    deposit: "入金",
    title: "農家のプロジェクト",
    activeProjects: "アクティブなプロジェクト",
    startNewProject: "新しいプロジェクトを開始",
    draftTitleFallback: "無題のプロジェクト",
    jobsCreated: "件の雇用が創出されました",
    seeProjectPage: "ページを見る",
    edit: "編集",
    updateProduction: "生産を更新",
    updateStage: "ステージを更新",
    awaitingApproval: "承認待ち"
  },
  farmerForm: {
    enterYearlyCost: "年 {years} に少なくとも 1 つのコスト項目を入力してください。",
    tellUsTitle: "あなたのプロジェクトについて教えてください",
    tellUsDescription: "伝統的なアグロフォレストの維持でも、新たなフードフォレストの立ち上げでも、このフォームはあなたのストーリーを理解し、データを構造化し、投資の準備を整えるのに役立ちます。",
    startApplication: "申請を開始",
    step1Title: "プロジェクトの提出",
    step1Description: "基本情報、種のデータ、財務情報を共有します。",
    step2Title: "レビューと調整",
    step2Description: "当チームがデータの確認や改善のため連絡する場合があります。",
    step3Title: "資金調達の準備完了",
    step3Description: "検証後、プロジェクトは気候に配慮した投資の対象となります。",
    sidebarTitle: "プロジェクト分析",
    sidebarSubtitle: "フォームを入力して分析を確認しましょう",
    submit: "提出する",
    save: "保存する",
    previous: "前へ",
    continue: "続行",
    finishCosts: "コスト入力を完了",
    nextSpecies: "次の樹種へ",
    seeAnalysis: "分析を見る",
    stepProduction: {
      productionDelay: "生産の遅れ（月単位）",
      inKg: "年間あたりのキログラム単位",
      sellingPricePerKg: "販売価格",
      currentProduction: "現在の生産量",
      currentHarvest: "現在の収穫量",
      nextYearProduction: "来年の生産量",
      production: "生産量",
      years: "年",
      expectedAmount: "予想数量"
    },
    stepPlanting: {
      trees: "樹木",
      plantingAreaSize: "植栽面積",
      areaPlaceholder: "00.00 ヘクタール",
      uploadKML: "KMLファイルをアップロード",
      photos: "写真",
      photoHint: "生産の写真を含めてください",
      speciesPlaceholder: "樹種名",
      quantityPlaceholder: "本数",
      addTree: "樹種を追加"
    },
    stepOverview: {
      speciesPlanted: "植えられた種",
      expansion: "拡張",
      maintenance: "維持管理",
      value_addition: "付加価値",
      projectOwner: "プロジェクトオーナー",
      projectOwnerPlaceholder: "プロジェクトオーナーを入力",
      projectTitle: "プロジェクトタイトル",
      projectTitlePlaceholder: "プロジェクトタイトルを入力",
      projectType: "プロジェクトの種類",
      learnMore: "詳細を見る",
      jobsCreated: "創出された雇用数",
      jobsPlaceholder: "00.00",
      biome: "バイオーム",
      selectBiome: "プロジェクトのバイオームを選択",
      speciesCount: "システム内の種の数",
      speciesPlaceholder: "00.00",
      state: "州",
      selectState: "州を選択",
      city: "市",
      cityPlaceholder: "市名を入力",
      investment: "投資額 R$",
      investmentCon: "投資額 USD$",
      investmentPlaceholder: "00.00",
      projectYears: "プロジェクト年数",
      yearsPlaceholder: "年数を入力",
      photos: "写真",
      photoHint: "プロジェクト区域の写真をアップロードしてください。",
      supportingDocuments: "補足資料",
      supportingDocumentsHint: "プロジェクトの補足資料を添付してください。",
      docHint: "例：資金計画、植林設計、地図、写真",
      expansionDescription: "新しいアグロフォレストリー生産能力を作ります。",
      maintenanceDescription: "既存生産の継続的な維持管理に資金を充てます。",
      valueAdditionDescription: "加工やその他の付加価値化作業に資金を充てます。",
      description: "プロジェクトの説明",
      descriptionPlaceholder: "プロジェクトの説明を入力"
    },
    stepCosts: {
      inputPlaceholder: "00.00",
      systemWide: "全体システム {year}",
      culture: "{name} の栽培 {year}",
      "Planning & Design": "計画と設計",
      "Site preparation": "用地準備",
      "Planting & establishment": "植栽と確立",
      "Maintenance and care": "維持と管理",
      "Harvest & Post-Harvest": "収穫と収穫後処理",
      "Value addition": "付加価値化",
      "Marketing and distribution": "マーケティングと流通",
      "Site Preparation": "用地準備",
      "Planting & Establishment": "植栽と確立",
      "Maintenance & Care": "維持と管理",
      "Value Addition": "付加価値化",
      "Marketing & Distribution": "マーケティングと流通",
      Labor: "労働",
      Inputs: "資材",
      Materials: "材料",
      "Tools & Equipment": "道具・設備",
      "Services/Consultancy": "サービス・コンサルティング",
      Infrastructure: "インフラ",
      repeatYearly: "毎年繰り返す",
      recurring: "毎年発生",
      oneTime: "一度のみ",
      toolName: "名称",
      toolCost: "コスト",
      addTool: "ツール/機器を追加",
      removeTool: "削除",
      noTools: "登録されたツールはありません"
    },
    stepBiome: {
      deforestedArea: "バイオーム内の森林減少面積",
      plantSpecies: "バイオーム内の植物種数",
      animalSpecies: "バイオーム内の動物種数"
    },
    stepImpact: {
      cropDiversity: "システム内の作物多様性の数",
      waterAvailability: "土壌の水の利用可能性の増加",
      soilFertility: "土壌の生命・肥沃度の増加",
      faunaIncrease: "地域の動物相の増加",
      landConversion: "牧草地または農地からアグロフォレストリーへの転換",
      foodProduction: "再生可能な食品の生産量の増加",
      riverbankRestoration: "河岸沿いの森林再生",
      carbonSequestration: "地上および地下での炭素隔離",
      landConversion_placeholder: "ヘクタール",
      foodProduction_placeholder: "トン/年",
      riverbankRestoration_placeholder: "km",
      carbonSequestration_placeholder: "トン/年"
    },
    stepAnalisys: {
      avgYROI: "平均年間ROI",
      increaseRevenue: "収益の増加",
      effectivePayback: "実質回収期間",
      monthlyPayments: "月次支払い",
      months: "か月",
      investmentCost: "投資コスト",
      additionalRevenue: "追加収益",
      safePaybackStart: "回収開始",
      years: "年",
      chartTitle: "収益分配予測",
      chartSubtitleShort: "短期プロジェクトでは、投資家が最大50％のROIに達するまで収益を50/50で分配します。",
      chartSubtitleLong: "長期プロジェクトでは、選択された年数後に農家がコストを負担しつつ収益を分配します。",
      farmerShare: "農家の取り分",
      investorShare: "投資家の取り分",
      yearlyBreakdownTitle: "年間収益分配",
      yearlyBreakdownDescription: "年間ごとの予測支払い、純収益、投資家／農家の分配。",
      yearColumn: "年",
      paymentsColumn: "支払い",
      revenueColumn: "収益",
      splitColumn: "収益分配",
      noSplitData: "まだ有効ではありません",
      acceptTerms: "利用規約に同意する",
      accept: "同意する",
      termsTitle: "利用規約",
      termsText1: "本規約において：「プラットフォーム」とはBrazil Carbonを、「投資者」とはプラットフォームを通じてプロジェクトに投資する個人または法人を、「生産者」とはプロジェクト登録において特定された農業生産者を意味し、「プロジェクト区域」および「総支払義務額」はプラットフォーム上で承認されたプロジェクト登録に記載されたものをいう。\n生産者は投資者のために、プロジェクト区域で得られる産品を参照対象とし、総支払義務額以上の金額を表示した金融型農産物証券（CPR-F）を発行するものとし、これはブラジル法（Lei nº 8.929/1994）に従う。CPR-Fは収穫暦に沿った満期を定め、管轄の登記機関または公証役場に登録される。法的に許容される場合、CPR-Fには以下を含む：\n (a) 当該産品の販売から生じる現在および将来の債権の信託的譲渡；および\n (b) 資金供与された生産物の作物または在庫に対する質権。\n生産者はプロジェクトを通常の方法で維持し、技術的勧告に従い、投資者の事前の書面による同意なく担保資産を処分または負担設定してはならない。\nサービス手数料：生産者は、プラットフォームが、契約時にプラットフォーム上で開示されプロジェクトのスマートコントラクトに記録された料率で、生産者への支払額からサービス手数料を控除することを了承する。\n資金の保管および利用可能性：支払い前の資金はスマートコントラクトで保管され、第三者のデジタル資産プロトコルに一時的に配分されることがある。スマートコントラクトまたは第三者プロトコルに影響するセキュリティ事故（ハッキング等）、当該プロトコルの破綻、使用されるステーブルコインの価格乖離、ブロックチェーンネットワークの障害、政府の行為など、両当事者の合理的な支配を超える事由により、支払いが遅延、減額または不能となることがある。かかる事由はブラジル民法第393条の不可抗力に該当し、プラットフォームおよび投資者は、影響の軽減と資金回収に誠実に努める限り、これに起因する損失について責任を負わない。\n責任制限：法律で認められる最大限の範囲で、プラットフォームおよび投資者の生産者に対する責任の総額は直接損害に限定され、プロジェクトに実際に拠出された金額を超えないものとし、間接損害および逸失利益は除外される。\n債務不履行および是正期間：生産者による違反の場合、投資者は書面で通知し、生産者は担保の実行または期限の利益喪失の前に30日間の是正期間を有する。\n両当事者は、生産者および関係者の個人データの収集、処理、保管および共有がブラジル一般データ保護法（Lei nº 13.709/2018 – LGPD）に従うことを確認する。個人データは、プロジェクトの検証、モニタリング、支払処理、リスク評価および規制遵守に関連する目的にのみ使用される。生産者はかかる処理に同意し、法律の許す範囲で個人データへのアクセス、訂正または削除を請求できる。投資者は、個人データを不正アクセス、喪失または濫用から保護するため、適切な管理的、技術的および安全対策を講じる。\n本書はブラジル連邦共和国の法律に準拠する。紛争はプロジェクト区域の所在地を管轄する裁判所に提起される。本規約はポルトガル語版が優先し、本日本語版は参考訳である。\n",
      termsText2: "本規約において：「プラットフォーム」とはBrazil Carbonを、「投資者」とはプラットフォームを通じてプロジェクトに投資する個人または法人を、「生産者」とはプロジェクト登録において特定された農業生産者を意味し、「プロジェクト区域」および「総支払義務額」はプラットフォーム上で承認されたプロジェクト登録に記載されたものをいう。\n資金供与された機械・設備・付帯設備は、投資者に対する所有権移転担保（alienação fiduciária）の対象となり、署名および管轄機関への登録により効力を生じる。総支払義務額の完済まで、生産者は：\n (a) 当該資産を売却、賃貸、移動または負担設定しない；\n (b) 良好な稼働状態を維持する；および\n (c) 投資者を第一受益者とする保険を維持する。\n債務不履行の場合、法律の許す範囲で、投資者は担保物の占有を取得して売却し、その代金を未払残高に充当することができる。\nサービス手数料：生産者は、プラットフォームが、契約時にプラットフォーム上で開示されプロジェクトのスマートコントラクトに記録された料率で、生産者への支払額からサービス手数料を控除することを了承する。\n資金の保管および利用可能性：支払い前の資金はスマートコントラクトで保管され、第三者のデジタル資産プロトコルに一時的に配分されることがある。スマートコントラクトまたは第三者プロトコルに影響するセキュリティ事故（ハッキング等）、当該プロトコルの破綻、使用されるステーブルコインの価格乖離、ブロックチェーンネットワークの障害、政府の行為など、両当事者の合理的な支配を超える事由により、支払いが遅延、減額または不能となることがある。かかる事由はブラジル民法第393条の不可抗力に該当し、プラットフォームおよび投資者は、影響の軽減と資金回収に誠実に努める限り、これに起因する損失について責任を負わない。\n責任制限：法律で認められる最大限の範囲で、プラットフォームおよび投資者の生産者に対する責任の総額は直接損害に限定され、プロジェクトに実際に拠出された金額を超えないものとし、間接損害および逸失利益は除外される。\n債務不履行および是正期間：生産者による違反の場合、投資者は書面で通知し、生産者は担保の実行または期限の利益喪失の前に30日間の是正期間を有する。\n両当事者は、生産者および関係者の個人データの収集、処理、保管および共有がブラジル一般データ保護法（Lei nº 13.709/2018 – LGPD）に従うことを確認する。個人データは、プロジェクトの検証、モニタリング、支払処理、リスク評価および規制遵守に関連する目的にのみ使用される。生産者はかかる処理に同意し、法律の許す範囲で個人データへのアクセス、訂正または削除を請求できる。投資者は、個人データを不正アクセス、喪失または濫用から保護するため、適切な管理的、技術的および安全対策を講じる。\n本書はブラジル連邦共和国の法律に準拠する。紛争はプロジェクト区域の所在地を管轄する裁判所に提起される。本規約はポルトガル語版が優先し、本日本語版は参考訳である。\n",
      termsText3: "",
      termsText4: ""
    },
    searchOrDrag: "検索またはドラッグ＆ドロップ",
    steps: {
      information: "情報",
      overview: "概要",
      planting: "植栽",
      costs: "コスト",
      production: "生産",
      analysis: "分析",
      impact: "影響"
    },
    nested: {
      systemWide: "全体システム {year}",
      systemWideGroup: "全体システム",
      speciesYear: "{species} {year}",
      systemWideProd: "全体システム",
      species: "{species}"
    }
  },
  accountDetails: {
    back: "戻る",
    save: "保存",
    wallet: "ウォレット",
    legalAddress: "法的住所",
    registrationDate: "登録日",
    kyc: "KYC",
    email: "メールアドレス",
    verifyEmail: "メールを確認",
    emailVerificationRequested: "メール確認をリクエストしました",
    kycVerified: "確認済み",
    kycBlocked: "ブロック",
    kycNotVerified: "未確認",
    verifyKycNow: "今すぐ確認",
    kycVerificationSucceeded: "KYC確認が完了しました",
    kycVerificationFailed:
      "KYC確認を完了できませんでした。もう一度お試しください。",
    close: "閉じる"
  },
  userSidePanel: {
    co2Farmed: "CO₂ 生産量",
    bctLocked: "ロックされたBCT",
    close: "閉じる",
    co2CapturedToday: "のCO₂を本日吸収",
    buy: "購入",
    farm: "農園",
    play: "プレイ",
    assets: "資産",
    investments: "投資",
    farming: "ファーミング",
    unrealizedProfit: "未実現利益",
    averagePaid: "平均取得単価",
    investmentUnits: "投資単位"
  },
  walletPage: {
    account: "アカウント",
    export: "エクスポート",
    carbonCreditsTitle: "カーボンクレジット",
    co2: "CO/2",
    cacaoTitle: "カカオ",
    acaiTitle: "アサイー",
    inProjects: "{count} 件のプロジェクトに参加",
    co2Farmed: "CO₂ ファーム済み",
    projectsOwned: "保有プロジェクト",
    assets: "資産",
    investments: "投資",
    bctStaked: "ロックされた BCT",
    totalBct: "合計 BCT",
    transactions: "取引履歴",
    unavailableTitle: "問題が発生しました",
    unavailableDescription: "現在ダッシュボードを読み込めません。しばらくしてからもう一度お試しください。",
    tryAgain: "再試行",
    transactionActions: {
      BUY: "購入",
      SELL: "売却",
      INVEST: "投資",
      CLAIM: "受け取り"
    },
  },
  stakeComponent: {
    stake: "ステーキング",
    unstake: "アンステーキング",
    alreadyStaked: "すでにロック済み",
    noStakes: "ステーキングなし",
    timeToUnstake: "アンロックの時間",
    readyToUnstake: "アンロック可能",
    login: "ログイン",
    enterAmount: "金額を入力してください",
    success: "成功",
    insufficientBalance: "残高不足",
    lock: "ロック",
    unlock: "ロック解除",
    durationDays: "期間（日）"
  },
  impactTab: {
    jobs_number: "創出された雇用",
    water_availability: "土壌の水分利用可能性",
    soil_fertility: "土壌の生命／肥沃度",
    crop_diversity: "作物の多様性",
    fauna_increase: "地域の動物相",
    land_conversion: "牧草地や農地から森林への転換",
    regenerative_food: "高品質な再生型食品の生産",
    riverbank_regeneration: "川岸に沿った森林の再生",
    carbon_sequestration: "地上／地下での炭素隔離",
    impactTabUnits: {
      none: "",
      hectares: "ヘクタール",
      tons: "トン",
      co2Tons: "CO2トン"
    }
  },
  common: {
    maxFileSize: "許可されている最大ファイルサイズは {max}MB です",
    dropFileHereOr: "ここにファイルをドロップ、または",
    browse: "参照",
    addMoreFiles: "さらにファイルを追加",
    replaceFile: "ファイルを置き換え",
    clearFiles: "ファイルをクリア",
    clearSelection: "選択をクリア",
    copied: "コピーしました",
    tokens: "トークン",
    claimUSDC: "USDCを請求する",
    enterLocation: "場所を入力してください",
    or: "または",
    profileChanged: "プロフィールの変更が保存されました",
    selectAnOption: "オプションを選択",
    today: "今日",
    yesterday: "昨日",
    projectSavedToDatabase: "プロジェクトはデータベースに正常に保存されました",
    projectSaved: "プロジェクトが正常に保存されました",
    projectCreated: "プロジェクトが正常に作成されました",
    approved: "承認済み",
    cancel: "キャンセル",
    update: "更新",
    delete: "削除",
    back: "戻る",
    home: "ホーム",
    close: "閉じる",
    download: "ダウンロード"
  },
  farmerFormValidation: {
    fillBeforeProceeding: "{field} を入力してください。",
    projectTitle: "プロジェクト名",
    projectDescription: "プロジェクトの説明",
    projectType: "プロジェクトタイプ",
    jobsCreated: "創出された雇用",
    biome: "バイオーム",
    state: "州",
    city: "市区町村",
    investmentCost: "投資コスト",
    projectOwner: "プロジェクトオーナー",
    projectYears: "プロジェクト期間（年）",
    supportingDocs: "支援書類",
    species: "換金作物（種）",
    duplicateSpecies:
      "種の重複: 同じ作物を異なる言語で入力することはできません。重複を削除してください。",
    areaSize: "植栽面積",
    photos: "プロジェクトの写真",
    productionDelay: "生産遅延（月）",
    totalSupply: "総供給量（kg）",
    finalPrice: "販売価格（kgあたり）",
    current: "現在",
    year: "年 {n}",
    systemYear: "システム全体の Y{year}",
    costLabels: {
      planning: "計画と設計",
      site_preparation: "現場準備",
      planting: "植栽と確立",
      maintenance: "保守と管理",
      harvest: "収穫と収穫後処理",
      value_addition: "付加価値",
      marketing: "マーケティングと流通"
    },
    costInputs: {
      labor: "労働力",
      inputs: "投入物",
      tools: "ツールと機器",
      services: "サービス／コンサルティング",
      infrastructure: "インフラ"
    },
    maxYearsExceeded: "プロジェクトの最大期間は{max}年です。1から{max}の値を入力してください。"
  },
  circleLogin: {
    sendResetLink: "リセットリンクを送信",
    forgotPassword: "パスワードをお忘れですか？",
    sendPasswordResetEmail: "パスワード再設定用メールを送信",
    enterEmail: "メールアドレスを入力してください。",
    enterEmailAndPassword: "メールアドレスとパスワードの両方を入力してください。",
    forgotPasswordMessageSent: "そのメールアドレスに対応するアカウントが存在する場合、再設定リンクをお送りします。",
    resetYourPassword: "パスワードをリセットする",
    newPassword: "新しいパスワード",
    confirmPassword: "パスワードを確認",
    saveNewPassword: "新しいパスワードを保存",
    passwordResetComplete: "パスワードが正常にリセットされました！ログインできます。",
    resetFailed: "パスワードのリセットに失敗しました。リンクが無効または期限切れの可能性があります。"
  },
  newTokenPage: {
    lockWithAmount: "{amount} BCT をロック",
    unlockWithAmount: "{amount} BCT をアンロック",
    totalBctLocked: "ロックされた合計BCT",
    nextSnapshotShare: "10,000 BCTの次回スナップショット比率",
    rewardPreviewUnavailable: "利用できません",
    numberProjects: "プロジェクト数",
    currentProjectSize: "現在のプロジェクト規模",
    thirdSectionDescription: "BCTを使用してCO₂をリアルタイムで捕捉 — カカオやアサイーなどからのカーボンクレジットとアグロフォレストリー報酬を継続的にストリーミングします。",
    growTitle: "自分の森を育てよう",
    growDescription: "私たちは、トークン保有者が熱帯雨林の生態系を育て、管理し、拡大して報酬を得る戦略的な放置型ゲームを構築しました。",
    growEnter: "近日公開",
    growAltMain: "成長セクションのイラスト",
    growAltPlant: "植物",
    growAltTimer: "タイマー",
    growAltChart: "グラフ",
    growItemSpecies: "リアルな種の\nモデリング",
    growItemTimer: "リアルタイムの\n自律成長",
    growItemChart: "生態系の健全性を維持することで\n増加するカーボンクレジット収益",
    gridItem1Title: "BCTトークンをロックする",
    gridItem1Description: "BCTロック（供給圧力）。ユーザーがBCTトークンをロックすることで流通供給量が減り、トークン価格が上昇します。",
    gridItem1RightTitle: "BCTトークンを購入",
    gridItem2Title: "あなたのロックは、検証済みの実世界プロジェクトから利回りを生み出します",
    gridItem2Description: "検証済みの実世界プロジェクトへの投資。BCT販売からの資金が、炭素・アグロフォレストリーのプロジェクトを直接支えます。",
    gridItem2RightTitle: "プロジェクトを見る",
    gridItem3Title: "生成された利回りを現地通貨で請求する。",
    gridItem3Description: "さまざまな利回り（カーボンクレジット、木材、果物、コーヒー、カカオなど）をUSD、EUR、BRLなどで請求できます。",
    gridItem3RightTitle: "もっと詳しく",
    faqTitle: "FAQ",
    faqItems: [
      {
        title: "Title",
        content: "description"
      },
      {
        title: "Title",
        content: "description"
      },
      {
        title: "Title",
        content: "description"
      }
    ],
    filterLock: "ロック",
    filterYield: "利回り",
    filterClaim: "請求"
  },
  farmerCard: {
    invested: "投資済み",
    deposited: "入金済み",
    stage: "ステージ",
    withdraw: "引き出す (ひきだす)",
    withdrawUSDC: "USDCを引き出す",
    updateProduction: "生産を更新",
    signStage: "ステージを署名",
    finalizeSpecies: "預け入れを確定",
    finalizeSummary: "次の預け入れを確定します",
    harvested: "収穫済み",
    harvestedAmount: "収穫量 (Kg)",
    pricePerKg: "販売価格 / Kg",
    noUsersToAllocate: "資金を割り当てるユーザーがいません",
    stageUnknown: "—"
  },
  calculateReturns: {
    title: "V2ステーキングウェイトを確認",
    description: "次回の報酬資金スナップショット時点の現在のオンチェーンウェイトに基づきます",
    yourDeposit: "ステーキングするBCT",
    days: "{count}日",
    nextSnapshotShare: "次回スナップショットの推定比率",
    ageHalfLife: "ゲーム年齢の半減期",
    lockNow: "BCTをステーキング",
    rewardAsset: "ERC-1155プロジェクト受領トークン報酬",
    rewardModelTitle: "スナップショット資金型報酬",
    rewardModelExplanation: "各受領トークンの資金ラウンドで、対象ステーカーと有効ウェイトが固定されます。ステークが有効になった後に資金提供されたラウンドだけが対象です。",
    noApy: "V2はAPYを保証しません。将来の受領トークン資金、プロジェクトトークン価格、他のステーカーのウェイトは未確定で、既存ラウンドは元のスナップショットを維持します。",
    totalStaked: "現在の総ステーク",
    activeStakers: "アクティブステーカー",
    fundedRounds: "資金提供済みラウンド",
    configuredHalfLife: "設定済み報酬半減期",
    snapshotStatus: "スナップショット書き込み",
    snapshotReady: "準備完了",
    snapshotInProgress: "スナップショット中はロック",
    loading: "現在のV2報酬状態を読み込み中…",
    invalidAmount: "有効なBCT数量を入力してください。",
    unavailable: "V2報酬状態を取得できません。"
  },
  developerRegistration: {
    introTitle: "開発者として登録",
    introSubtitle: "伝統的なアグロフォレストリーや新しいフードフォレストシステムの立ち上げについて、このフォームで背景を確認し、データを整理してインパクト投資に備えます。",
    getStarted: "開始する",
    noWallet: "ウォレットをお持ちでないですか？",
    learnWallet: "ウォレットの作成方法を見る",
    formTitle: "開発者として登録",
    fullName: "氏名",
    email: "メール",
    phoneNumber: "電話番号",
    walletAddress: "ウォレットアドレス",
    connectWallet: "ウォレットを接続",
    iRepresentCompany: "会社を代表しています",
    company: "会社",
    companyRegistryNumber: "会社登録番号",
    dateOfIncorporation: "設立日",
    websiteUrl: "ウェブサイトURL",
    uploadCompanyLogo: "会社ロゴをアップロード",
    dropFilesHere: "ここにファイルをドロップ、または",
    browse: "参照",
    continueToKyc: "KYCへ進む",
    submitKycLater: "送信してKYCは後で行う",
    verifyTitle: "メールを確認",
    verifySubtitle: "メールアドレスに確認コードを送信しました。続行するには下にコードを入力してください。",
    submitCode: "コードを送信",
    requestNewCode: "新しいコードをリクエスト",
    verificationComplete: "確認が完了しました",
    verificationMessage: "情報の確認が完了しました。アカウントの審査中でも、プロジェクトを作成できます。",
    createProject: "プロジェクトを作成"
  },
  partnerPage: {
    hectares: "ヘクタール",
    projectType: "プロジェクトタイプ",
    step1Title: "プロジェクト詳細",
    step2Title: "プロジェクトファイル",
    resultTitle: "結果",
    addProjectFiles: "プロジェクトファイルを追加",
    uploadProjectPhotos: "プロジェクトの写真をアップロード (最大16枚のJPG、JPEG、PNG)",
    uploadForestPhoto: "森林被覆の写真をアップロード (最大1枚のJPG、JPEG、PNG)",
    uploadProjectFiles: "プロジェクトファイルをアップロード (最大4つのPDF)",
    photosUploading: "写真をアップロード中...",
    filesUploading: "ファイルをアップロード中...",
    upload: "アップロード",
    progress: "進捗",
    results: "結果",
    projectData: "プロジェクトデータ",
    noPhotos: "なし",
    images: "画像",
    projectPhotos: "プロジェクトの写真",
    projectFiles: "プロジェクトファイル",
    noFiles: "なし",
    pdfs: "PDFファイル",
    noFileUploaded: "ファイルがアップロードされていません",
    back: "戻る",
    continue: "続ける",
    backToProjectsList: "プロジェクト一覧に戻る",
    finished: "完了!",
    nameForText: "プロジェクト名",
    auditor: "プロジェクト監査人",
    state: "ブラジルの州を選択",
    carbonCreditSupply: "カーボンクレジット供給量",
    listingPrice: "上場価格",
    overview: "概要",
    biodiversity: "生物多様性",
    floraCount: "植物種数",
    faunaCount: "動物種数",
    endangeredSpeciesCount: "絶滅危惧種の数",
    userNotAuthenticated: "ユーザーが認証されていません",
    summary: "プロジェクト概要",
    commission: "パートナーUSD手数料",
    creditCommission: "パートナーカーボンクレジット手数料",
    calcReddCost: "REDD+ コストを計算",
    auditorVerification: "検証監査人",
    auditorValidation: "検証監査",
    projectPartner: "プロジェクトパートナー",
    projectCertifier: "プロジェクト認証機関",
    selectBrazilState: "ブラジルの州を選択",
    inflationRate: "インフレ率",
    projectCoBenefitors: "プロジェクト共益者",
    landOwner: "土地所有者",
    forestCover: "森林被覆",
    yearsPeriod: "プロジェクトの期間（年）",
    investorsPercent: "投資家 (%)",
    ownersPercent: "所有者 (%)",
    partnersPercent: "開発者（％）",
    platformPercent: "プラットフォーム (%)",
    stakersPercent: "ステーカー（%）",
    historicalDeforestationRate: "過去の森林減少率 (0-1)",
    carbonSequestrationRate: "炭素隔離率（トン/年）",
    deforestationDrivers: "森林破壊要因",
    deforestationAgents: "森林破壊の原因",
    ecosystemServicesValuation: "生態系サービスの評価",
    biomeAreaHectares: "バイオーム面積 (ヘクタール)",
    auditorFee: "監査料 (%)",
    auditCost: "監査コスト",
    tokenName: "トークン名",
    tokenSymbol: "トークンシンボル",
    registerAsDeveloper: "開発者として登録",
    numberCarbonCredits: "カーボンクレジット数"
  }
};
